import React from "react";

import "./styles.scss";

export default function Hospital() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            id="freepik_stories-hospital-wheelchair"
            className="animated"
            version="1.1"
            viewBox="0 0 500 500"
        >
            <g
                id="freepik--Floor--inject-2"
                style={{
                    WebkitTransformOrigin: 250,
                    MsTransformOrigin: 250,
                    transformOrigin: 250,
                }}
                className="animable"
            >
                <path
                    id="freepik--floor--inject-2"
                    d="M90.75 268.8c-87.95 50.78-87.95 133.1 0 183.88s230.55 50.78 318.5 0 87.95-133.1 0-183.88-230.55-50.8-318.5 0z"
                    style={{
                        WebkitTransformOrigin: 250,
                        MsTransformOrigin: 250,
                        transformOrigin: 250,
                    }}
                    fill="#FAFAFA"
                    className="animable"
                ></path>
            </g>
            <g
                id="freepik--Shadows--inject-2"
                style={{
                    WebkitTransformOrigin: 240.114,
                    MsTransformOrigin: 240.114,
                    transformOrigin: 240.114,
                }}
                className="animable"
            >
                <path
                    id="freepik--Shadow--inject-2"
                    d="M210.82 389.57l96.08-55.47a10.89 10.89 0 019.82 0l114 65.84c2.7 1.56 2.71 4.12 0 5.69l-13.09 7.62 12.42 7.17c2.7 1.56 2.7 4.12 0 5.69l-58.95 34.32a10.84 10.84 0 01-9.81 0l-12.42-7.17-13.81 8a10.81 10.81 0 01-9.8 0l-114.5-66.1c-2.64-1.48-2.64-4.03.06-5.59z"
                    style={{
                        WebkitTransformOrigin: 320.768,
                        MsTransformOrigin: 320.768,
                        transformOrigin: 320.768,
                    }}
                    fill="#E0E0E0"
                    className="animable"
                ></path>
                <path
                    id="freepik--shadow--inject-2"
                    d="M114.7 361.12c15.37 9 15.37 23.53 0 32.51s-40.31 9-55.69 0-15.37-23.53 0-32.51 40.31-8.98 55.69 0z"
                    style={{
                        WebkitTransformOrigin: 86.8531,
                        MsTransformOrigin: 86.8531,
                        transformOrigin: 86.8531,
                    }}
                    fill="#E0E0E0"
                    className="animable"
                ></path>
                <path
                    id="freepik--shadow--inject-2"
                    d="M157.16 347.19c-28.52 16.46-28.52 43.16 0 59.63s74.76 16.46 103.28 0 28.52-43.16 0-59.63-74.76-16.47-103.28 0z"
                    style={{
                        WebkitTransformOrigin: 208.8,
                        MsTransformOrigin: 208.8,
                        transformOrigin: 208.8,
                    }}
                    fill="#E0E0E0"
                    className="animable"
                ></path>
            </g>
            <g
                id="freepik--Window--inject-2"
                style={{
                    WebkitTransformOrigin: 407.105,
                    MsTransformOrigin: 407.105,
                    transformOrigin: 407.105,
                }}
                className="animable"
            >
                <g
                    id="freepik--window--inject-2"
                    style={{
                        WebkitTransformOrigin: 407.105,
                        MsTransformOrigin: 407.105,
                        transformOrigin: 407.105,
                    }}
                    className="animable"
                >
                    <g
                        id="freepik--window--inject-2"
                        style={{
                            WebkitTransformOrigin: 407.105,
                            MsTransformOrigin: 407.105,
                            transformOrigin: 407.105,
                        }}
                        className="animable"
                    >
                        <g
                            id="freepik--Frame--inject-2"
                            style={{
                                WebkitTransformOrigin: 407.105,
                                MsTransformOrigin: 407.105,
                                transformOrigin: 407.105,
                            }}
                            className="animable"
                        >
                            <path
                                style={{
                                    WebkitTransformOrigin: 407.085,
                                    MsTransformOrigin: 407.085,
                                    transformOrigin: 407.085,
                                }}
                                id="el8ilava044mi"
                                fill="#FAFAFA"
                                d="M455.31 248.99L452.56 250.64 358.86 196.54 361.61 194.9 455.31 248.99z"
                                className="animable"
                            ></path>
                            <path
                                style={{
                                    WebkitTransformOrigin: 407.085,
                                    MsTransformOrigin: 407.085,
                                    transformOrigin: 407.085,
                                }}
                                id="elufr42a7wxo"
                                fill="#FFF"
                                d="M361.61 194.9L452.56 247.4 452.56 95.24 361.61 42.76 361.61 194.9z"
                                className="animable"
                            ></path>
                            <path
                                d="M353.66 199.54l104.1 60.1V92.24l-104.1-60.1zm5.2-158.39l93.7 54.09v155.4l-93.7-54.1z"
                                style={{
                                    WebkitTransformOrigin: 405.71,
                                    MsTransformOrigin: 405.71,
                                    transformOrigin: 405.71,
                                }}
                                id="elem4xc86ou9w"
                                fill="#F0F0F0"
                                className="animable"
                            ></path>
                            <path
                                style={{
                                    WebkitTransformOrigin: 360.235,
                                    MsTransformOrigin: 360.235,
                                    transformOrigin: 360.235,
                                }}
                                id="eliw092tu58pj"
                                fill="#E0E0E0"
                                d="M358.86 196.54L361.61 194.9 361.61 42.76 358.86 41.15 358.86 196.54z"
                                className="animable"
                            ></path>
                            <path
                                style={{
                                    WebkitTransformOrigin: 405.71,
                                    MsTransformOrigin: 405.71,
                                    transformOrigin: 405.71,
                                }}
                                id="elu78u1pucrtg"
                                fill="#FAFAFA"
                                d="M452.56 203.09L452.56 206.32 358.86 152.22 361.61 150.58 452.56 203.09z"
                                className="animable"
                            ></path>
                            <path
                                style={{
                                    WebkitTransformOrigin: 405.71,
                                    MsTransformOrigin: 405.71,
                                    transformOrigin: 405.71,
                                }}
                                id="els17lvksy7sq"
                                fill="#FAFAFA"
                                d="M452.56 130.34L452.56 133.58 358.86 79.48 361.61 77.84 452.56 130.34z"
                                className="animable"
                            ></path>
                            <path
                                style={{
                                    WebkitTransformOrigin: 407.105,
                                    MsTransformOrigin: 407.105,
                                    transformOrigin: 407.105,
                                }}
                                id="el1grperssmcm"
                                fill="#FAFAFA"
                                d="M353.66 32.14L356.46 30.54 460.55 90.64 457.76 92.24 353.66 32.14z"
                                className="animable"
                            ></path>
                            <path
                                style={{
                                    WebkitTransformOrigin: 459.155,
                                    MsTransformOrigin: 459.155,
                                    transformOrigin: 459.155,
                                }}
                                id="elt92ivy2twbj"
                                fill="#E0E0E0"
                                d="M460.55 90.64L457.76 92.24 457.76 259.64 460.55 258.04 460.55 90.64z"
                                className="animable"
                            ></path>
                            <path
                                style={{
                                    WebkitTransformOrigin: 411.08,
                                    MsTransformOrigin: 411.08,
                                    transformOrigin: 411.08,
                                }}
                                id="elwciz2m2scm"
                                fill="#E0E0E0"
                                d="M412.48 72.11L409.68 70.49 409.68 225.89 412.48 224.29 412.48 72.11z"
                                className="animable"
                            ></path>
                        </g>
                        <path
                            style={{
                                WebkitTransformOrigin: 407.085,
                                MsTransformOrigin: 407.085,
                                transformOrigin: 407.085,
                            }}
                            id="eligfcholhl4l"
                            fill="#F0F0F0"
                            d="M404.49 67.5L409.68 70.49 409.68 225.89 404.49 222.88 404.49 67.5z"
                            className="animable"
                        ></path>
                        <path
                            style={{
                                WebkitTransformOrigin: 405.71,
                                MsTransformOrigin: 405.71,
                                transformOrigin: 405.71,
                            }}
                            id="eldcusvu2luhv"
                            fill="#F0F0F0"
                            d="M353.66 76.48L353.66 82.47 457.76 142.57 457.76 136.58 353.66 76.48z"
                            className="animable"
                        ></path>
                        <path
                            style={{
                                WebkitTransformOrigin: 405.71,
                                MsTransformOrigin: 405.71,
                                transformOrigin: 405.71,
                            }}
                            id="el9863tg8x51v"
                            fill="#F0F0F0"
                            d="M353.66 149.21L353.66 155.2 457.76 215.3 457.76 209.31 353.66 149.21z"
                            className="animable"
                        ></path>
                        <path
                            style={{
                                WebkitTransformOrigin: 431.12,
                                MsTransformOrigin: 431.12,
                                transformOrigin: 431.12,
                            }}
                            id="elvh7cl4i7th"
                            fill="#FAFAFA"
                            d="M409.68 108.83L412.48 107.21 452.56 130.34 452.56 133.58 409.68 108.83z"
                            className="animable"
                        ></path>
                        <path
                            style={{
                                WebkitTransformOrigin: 431.12,
                                MsTransformOrigin: 431.12,
                                transformOrigin: 431.12,
                            }}
                            id="elhpwrs117i3t"
                            fill="#FAFAFA"
                            d="M409.68 181.53L412.48 179.92 452.56 203.05 452.56 206.29 409.68 181.53z"
                            className="animable"
                        ></path>
                    </g>
                </g>
            </g>
            <g
                id="freepik--Plant--inject-2"
                style={{
                    WebkitTransformOrigin: 84.78,
                    MsTransformOrigin: 84.78,
                    transformOrigin: 84.78,
                }}
                className="animable"
            >
                <g
                    id="freepik--plant--inject-2"
                    style={{
                        WebkitTransformOrigin: 84.78,
                        MsTransformOrigin: 84.78,
                        transformOrigin: 84.78,
                    }}
                    className="animable"
                >
                    <g
                        id="freepik--Pot--inject-2"
                        style={{
                            WebkitTransformOrigin: 84.78,
                            MsTransformOrigin: 84.78,
                            transformOrigin: 84.78,
                        }}
                        className="animable"
                    >
                        <g
                            id="freepik--pot--inject-2"
                            style={{
                                WebkitTransformOrigin: 86.8624,
                                MsTransformOrigin: 86.8624,
                                transformOrigin: 86.8624,
                            }}
                            className="animable"
                        >
                            <path
                                d="M111.55 379.63c13.2-13.63 21-51.79 8.08-62.6H54.08c-12.88 10.8-5.13 49 8.07 62.58.12.13.25.25.36.38l.46.45c.37.36.77.72 1.19 1.07l.32.25c.32.26.64.52 1 .76q.86.62 1.71 1.11c10.87 6.34 28.48 6.34 39.35 0 .58-.33 1.15-.71 1.72-1.11.33-.23.62-.47.93-.71l.39-.31c.41-.34.79-.69 1.15-1l.52-.52z"
                                style={{
                                    WebkitTransformOrigin: 86.8624,
                                    MsTransformOrigin: 86.8624,
                                    transformOrigin: 86.8624,
                                }}
                                id="elv7v5i89irn"
                                fill="#EBEBEB"
                                className="animable"
                            ></path>
                            <path
                                d="M59.77 312.67c-15 8.74-15 22.89 0 31.62s39.21 8.74 54.16 0 15-22.88 0-31.62-39.2-8.73-54.16 0z"
                                style={{
                                    WebkitTransformOrigin: 86.8406,
                                    MsTransformOrigin: 86.8406,
                                    transformOrigin: 86.8406,
                                }}
                                id="elznxkl85g0km"
                                fill="#F5F5F5"
                                className="animable"
                            ></path>
                            <path
                                d="M67 316.87c-11 6.42-11 16.81 0 23.22s28.79 6.42 39.77 0 11-16.81 0-23.23-28.77-6.4-39.77.01z"
                                style={{
                                    WebkitTransformOrigin: 86.8813,
                                    MsTransformOrigin: 86.8813,
                                    transformOrigin: 86.8813,
                                }}
                                id="elglr1wzlrmar"
                                fill="#E0E0E0"
                                className="animable"
                            ></path>
                            <path
                                d="M106.74 327.89c-11-6.41-28.79-6.41-39.77 0a18.49 18.49 0 00-6.58 6.1 18.32 18.32 0 006.58 6.1c11 6.42 28.79 6.42 39.77 0a18.32 18.32 0 006.58-6.1 18.49 18.49 0 00-6.58-6.1z"
                                style={{
                                    WebkitTransformOrigin: 86.855,
                                    MsTransformOrigin: 86.855,
                                    transformOrigin: 86.855,
                                }}
                                id="eld58la0bpvru"
                                fill="#FAFAFA"
                                className="animable"
                            ></path>
                        </g>
                        <g
                            id="freepik--Plants--inject-2"
                            style={{
                                WebkitTransformOrigin: 84.78,
                                MsTransformOrigin: 84.78,
                                transformOrigin: 84.78,
                            }}
                            className="animable"
                        >
                            <path
                                d="M68 239.46l17.63 18.2-17.88-11.3a53.07 53.07 0 00.93 18.48s8.64 6.82 13.44 12.45l-13.83-7.68s-2.27 9.49-.2 24.69c.55 4 3.9 11.88 5.91 17.73a63.25 63.25 0 003.27 7.87c.07.17.16.32.24.49q5.39-2.2 11.13-4.19c3-4.62 7.66-16.41 10.08-26.24 9.22-37.66-16.79-63.35-39-73.75-.03 0 6.63 11.06 8.28 23.25z"
                                style={{
                                    WebkitTransformOrigin: 80.1741,
                                    MsTransformOrigin: 80.1741,
                                    transformOrigin: 80.1741,
                                }}
                                id="ellww8xh1e68e"
                                fill="#EBEBEB"
                                className="animable"
                            ></path>
                            <path
                                d="M84.27 243.22c3.49 4.57 5.14 10.2 6.24 15.75a78.09 78.09 0 011.32 17 72.29 72.29 0 01-8.52 32.63.56.56 0 101 .54A73.05 73.05 0 0092.39 276a78.79 78.79 0 00-1.6-17.06c-1.2-5.58-2.96-11.21-6.52-15.72z"
                                style={{
                                    WebkitTransformOrigin: 87.8205,
                                    MsTransformOrigin: 87.8205,
                                    transformOrigin: 87.8205,
                                }}
                                id="els6ho0id61d"
                                fill="#FFF"
                                className="animable"
                            ></path>
                            <path
                                d="M157.69 253.19c-.53.63-9.15 11-21.94 31.06l-21.4 3.51 15.8 2.71-8.46 13.53-21.06 4.43L117.1 311s-4.52 16.07-16.27 22.8c-6.49 3.72-9.31 3.82-11.62 2.45-2.83-1.68-4.19-6.28-5.35-13.15s1.18-20.76 7.62-34.27a42.13 42.13 0 016.71-9.93c15.52-17.4 44.94-25.9 59.5-25.71z"
                                style={{
                                    WebkitTransformOrigin: 120.632,
                                    MsTransformOrigin: 120.632,
                                    transformOrigin: 120.632,
                                }}
                                id="el3hqow7qyfja"
                                fill="#F0F0F0"
                                className="animable"
                            ></path>
                            <path
                                d="M135.32 260.27c-11.06 4.9-21.51 11.6-29.71 20.67a58.69 58.69 0 00-10.15 15.18 55.35 55.35 0 00-4.59 17.61.05.05 0 000 .06.08.08 0 00.07-.05 70.86 70.86 0 015.55-17.12 65.8 65.8 0 019.78-15.05c7.93-9.09 18.15-16 29.05-21.19a.05.05 0 000-.08.05.05 0 000-.03z"
                                style={{
                                    WebkitTransformOrigin: 113.1,
                                    MsTransformOrigin: 113.1,
                                    transformOrigin: 113.1,
                                }}
                                id="elqdcbjd1auk"
                                fill="#FFF"
                                className="animable"
                            ></path>
                            <path
                                d="M11.87 262.39a49.26 49.26 0 015.94-.27 95 95 0 0123.11 3.45c2.8.76 5.61 1.66 8.39 2.69q2.09.76 4.14 1.65A65.73 65.73 0 0172 281.44a41.27 41.27 0 016.72 7.83c.25.38.51.74.74 1.12.6 1 1.14 2 1.66 2.92 6 10.84 7.16 18.64 7.63 27.36.37 6.77-1.22 14.69-2.42 16.07a2.84 2.84 0 01-.55.49c-1.81 1.4-4.93 1-10.94-1.72-12-5.36-18-21.17-18-21.17l15.67-4.15L51.69 308l-9.48-12.2 15-4.16-21-1.31c-14.34-18.19-23.7-27.34-24.27-27.9z"
                                style={{
                                    WebkitTransformOrigin: 50.3373,
                                    MsTransformOrigin: 50.3373,
                                    transformOrigin: 50.3373,
                                }}
                                id="el412xkylj6rb"
                                fill="#F0F0F0"
                                className="animable"
                            ></path>
                            <path
                                d="M17.81 262.12a95 95 0 0123.11 3.45c2.8.76 5.61 1.66 8.39 2.69q2.09.76 4.14 1.65A65.73 65.73 0 0172 281.44a41.27 41.27 0 016.72 7.83c.25.38.51.74.74 1.12.6 1 1.14 2 1.66 2.92 6 10.84 7.16 18.64 7.63 27.36.37 6.77-1.22 14.69-2.42 16.07a2.84 2.84 0 01-.55.49 3.53 3.53 0 01-1.22.58c.44-10.58-7.1-36.62-15.88-46.81-9.13-10.61-29.84-25.31-56.77-28.59a50.47 50.47 0 015.9-.29z"
                                style={{
                                    WebkitTransformOrigin: 50.3573,
                                    MsTransformOrigin: 50.3573,
                                    transformOrigin: 50.3573,
                                }}
                                id="elrz3jcbfkder"
                                fill="#E6E6E6"
                                className="animable"
                            ></path>
                            <path
                                d="M84.61 337.82a90.14 90.14 0 00-3.6-23 75 75 0 00-9.66-21.23c-4.54-6.46-10.67-11.53-17.1-15.92a87.19 87.19 0 00-21-10.13.07.07 0 00-.08 0 .06.06 0 000 .08 114.84 114.84 0 0120.32 11.09 83.2 83.2 0 019.12 7.07 50.6 50.6 0 017.85 8.38A73.76 73.76 0 0180.38 315a89.62 89.62 0 014.1 22.8.07.07 0 00.07.06.06.06 0 00.06-.04z"
                                style={{
                                    WebkitTransformOrigin: 58.8824,
                                    MsTransformOrigin: 58.8824,
                                    transformOrigin: 58.8824,
                                }}
                                id="elzcj74r232zd"
                                fill="#FFF"
                                className="animable"
                            ></path>
                        </g>
                    </g>
                </g>
            </g>
            <g
                id="freepik--Sign--inject-2"
                style={{
                    WebkitTransformOrigin: 87.945,
                    MsTransformOrigin: 87.945,
                    transformOrigin: 87.945,
                }}
                className="animable"
            >
                <g
                    id="freepik--sign--inject-2"
                    style={{
                        WebkitTransformOrigin: 87.945,
                        MsTransformOrigin: 87.945,
                        transformOrigin: 87.945,
                    }}
                    className="animable"
                >
                    <g
                        id="freepik--Box--inject-2"
                        style={{
                            WebkitTransformOrigin: 87.945,
                            MsTransformOrigin: 87.945,
                            transformOrigin: 87.945,
                        }}
                        className="animable"
                    >
                        <path
                            d="M132.22 40.33l-96 55.36a7.84 7.84 0 00-3.55 6.14V138a7.73 7.73 0 003.57 6.1l.26.16a7.94 7.94 0 007.11 0l96-55.36a7.83 7.83 0 003.54-6.13V46.55a7.74 7.74 0 00-3.56-6.1l-.27-.16a7.94 7.94 0 00-7.1.04z"
                            style={{
                                WebkitTransformOrigin: 87.91,
                                MsTransformOrigin: 87.91,
                                transformOrigin: 87.91,
                            }}
                            id="el0j6zp7epze99"
                            fill="#F5F5F5"
                            className="animable"
                        ></path>
                        <path
                            d="M43.64 144.23a8.07 8.07 0 01-7.11 0l-.26-.16A7.71 7.71 0 0132.7 138v-36.17a7.27 7.27 0 011.13-3.62l7.31 4.31a7 7 0 00-1 3.48v36.18c-.04 2.07 1.41 3.26 3.5 2.05z"
                            style={{
                                WebkitTransformOrigin: 38.17,
                                MsTransformOrigin: 38.17,
                                transformOrigin: 38.17,
                            }}
                            id="eltrsfynnolej"
                            fill="#E0E0E0"
                            className="animable"
                        ></path>
                        <path
                            d="M139.62 44.51l-96 55.36A7.81 7.81 0 0040.1 106v36.19c0 2.26 1.58 3.17 3.54 2l96-55.36a7.83 7.83 0 003.54-6.13V46.55c-.02-2.26-1.61-3.17-3.56-2.04z"
                            style={{
                                WebkitTransformOrigin: 91.64,
                                MsTransformOrigin: 91.64,
                                transformOrigin: 91.64,
                            }}
                            id="el1f5goarjrfh"
                            fill="#FAFAFA"
                            className="animable"
                        ></path>
                        <path
                            d="M141.2 45c.83 0 1 1 1 1.53v36.21a6.85 6.85 0 01-3 5.27l-96 55.36a2.26 2.26 0 01-1.08.35c-.84 0-1-1-1-1.53V106a6.84 6.84 0 013-5.27l96-55.36a2.23 2.23 0 011.08-.37m0-1a3.17 3.17 0 00-1.58.49l-96 55.36A7.81 7.81 0 0040.1 106v36.19c0 1.6.8 2.53 2 2.53a3.22 3.22 0 001.58-.49l96-55.36a7.83 7.83 0 003.54-6.13V46.55c0-1.6-.8-2.53-2-2.53z"
                            style={{
                                WebkitTransformOrigin: 91.66,
                                MsTransformOrigin: 91.66,
                                transformOrigin: 91.66,
                            }}
                            id="elscdwzbmolf"
                            fill="#F0F0F0"
                            className="animable"
                        ></path>
                    </g>
                    <path
                        d="M60.53 103.72a.27.27 0 01.33 0 .58.58 0 01.14.43v17a1.34 1.34 0 01-.14.58.8.8 0 01-.33.4l-2.24 1.3a.24.24 0 01-.32 0 .53.53 0 01-.14-.42v-6.46l-3.8 2.2v6.45a1.34 1.34 0 01-.14.58.84.84 0 01-.32.4l-2.25 1.3a.25.25 0 01-.32 0 .58.58 0 01-.14-.44V110a1.34 1.34 0 01.14-.58.84.84 0 01.32-.4l2.25-1.3a.24.24 0 01.32 0 .57.57 0 01.14.42v6.35l3.8-2.19V106a1.27 1.27 0 01.14-.58.86.86 0 01.32-.39z"
                        style={{
                            WebkitTransformOrigin: 55.9296,
                            MsTransformOrigin: 55.9296,
                            transformOrigin: 55.9296,
                        }}
                        id="el9ukyafc7jah"
                        fill="#BA68C8"
                        className="animable"
                    ></path>
                    <path
                        d="M63 109.18a14.44 14.44 0 01.42-3 13.18 13.18 0 011-2.86 11.64 11.64 0 011.65-2.48A8.47 8.47 0 0168.34 99a4.56 4.56 0 012.23-.72 2.53 2.53 0 011.65.58 3.57 3.57 0 011 1.66 8.7 8.7 0 01.42 2.54V107.75a14.26 14.26 0 01-.42 3 13.43 13.43 0 01-1 2.89 11.64 11.64 0 01-1.65 2.48 9.08 9.08 0 01-2.23 1.84 4.71 4.71 0 01-2.23.73 2.38 2.38 0 01-1.65-.58 3.71 3.71 0 01-1-1.67 8.7 8.7 0 01-.42-2.54v-2.3c0-.82-.04-1.6-.04-2.42zm7.51.22v-1.08-1.19-1.16-1a4.44 4.44 0 00-.18-1.11 1.57 1.57 0 00-.41-.72 1 1 0 00-.66-.27 1.83 1.83 0 00-.92.3 3.61 3.61 0 00-.93.77 4.38 4.38 0 00-.65 1 5.78 5.78 0 00-.42 1.19 8.22 8.22 0 00-.17 1.32V111.81a2.85 2.85 0 00.59 1.84c.34.38.87.37 1.58 0a3.69 3.69 0 001.57-1.78 7.06 7.06 0 00.6-2.47z"
                        style={{
                            WebkitTransformOrigin: 68.32,
                            MsTransformOrigin: 68.32,
                            transformOrigin: 68.32,
                        }}
                        id="elsa192lru9v"
                        fill="#BA68C8"
                        className="animable"
                    ></path>
                    <path
                        d="M80.13 92.14a4.53 4.53 0 012-.67 2.8 2.8 0 011.58.34 2.64 2.64 0 011 1.08 3.36 3.36 0 01.4 1.54 1.15 1.15 0 01-.11.47.79.79 0 01-.25.32l-2.24 1.29a.73.73 0 01-.39.12.71.71 0 01-.3-.15l-.16-.17a.82.82 0 00-.32-.19 1 1 0 00-.51-.05 2 2 0 00-.76.29 4.93 4.93 0 00-.62.43 3.21 3.21 0 00-.53.51 2.52 2.52 0 00-.38.63 1.84 1.84 0 00-.14.74.83.83 0 00.16.57.75.75 0 00.55.17 4.33 4.33 0 001-.16l1.57-.4a5.5 5.5 0 011.64-.22 2 2 0 011.18.45 2.49 2.49 0 01.7 1.17 7.43 7.43 0 01.23 2 8.94 8.94 0 01-.39 2.62 10.79 10.79 0 01-1.04 2.47 10.68 10.68 0 01-1.68 2.11 10.22 10.22 0 01-2.11 1.62 5.12 5.12 0 01-2.12.75 3 3 0 01-1.66-.3 2.66 2.66 0 01-1.08-1.12 3.85 3.85 0 01-.41-1.74 1.05 1.05 0 01.11-.48.62.62 0 01.25-.31l2.24-1.3a.68.68 0 01.38-.12.54.54 0 01.27.12l.2.22a1.34 1.34 0 00.37.28 1.18 1.18 0 00.59.1 2.14 2.14 0 00.86-.32 6.33 6.33 0 001.51-1.18 2 2 0 00.61-1.44.57.57 0 00-.22-.53 1.09 1.09 0 00-.67-.1 5.72 5.72 0 00-1.14.22c-.46.13-1 .26-1.63.41a2.47 2.47 0 01-2.58-.44 4.74 4.74 0 01-.81-3.16 9 9 0 01.33-2.35 11.34 11.34 0 011-2.38 11 11 0 011.53-2.14 8.62 8.62 0 011.99-1.62z"
                        style={{
                            WebkitTransformOrigin: 80.1858,
                            MsTransformOrigin: 80.1858,
                            transformOrigin: 80.1858,
                        }}
                        id="elkr2p8e4qsv9"
                        fill="#BA68C8"
                        className="animable"
                    ></path>
                    <path
                        d="M92.58 85.22a5.6 5.6 0 012-.75 2 2 0 011.49.3 2.7 2.7 0 01.93 1.38 7.92 7.92 0 01.33 2.5 12.23 12.23 0 01-.33 2.91A10.56 10.56 0 0196 94a9.34 9.34 0 01-1.49 2 8.9 8.9 0 01-2 1.53l-2.19 1.27v5.37a1.34 1.34 0 01-.14.58.84.84 0 01-.32.4l-2.25 1.3a.24.24 0 01-.32 0 .57.57 0 01-.14-.42V89a1.34 1.34 0 01.14-.58.84.84 0 01.32-.4zm-2.19 9.51l2.1-1.21a3.36 3.36 0 001.66-3c0-.74-.15-1.18-.47-1.32a1.28 1.28 0 00-1.19.2l-2.1 1.21z"
                        style={{
                            WebkitTransformOrigin: 92.2408,
                            MsTransformOrigin: 92.2408,
                            transformOrigin: 92.2408,
                        }}
                        id="elrgiyz9m2ia"
                        fill="#BA68C8"
                        className="animable"
                    ></path>
                    <path
                        d="M99.43 99.72a.25.25 0 01-.33 0 .56.56 0 01-.14-.42v-17a1.34 1.34 0 01.14-.58.8.8 0 01.33-.4l2.24-1.3a.24.24 0 01.32 0 .54.54 0 01.14.42v17a1.34 1.34 0 01-.13.56.84.84 0 01-.32.4z"
                        style={{
                            WebkitTransformOrigin: 100.545,
                            MsTransformOrigin: 100.545,
                            transformOrigin: 100.545,
                        }}
                        id="el4delzdiznag"
                        fill="#BA68C8"
                        className="animable"
                    ></path>
                    <path
                        d="M113.33 73.24a.25.25 0 01.32 0 .58.58 0 01.14.43v2.79a1.37 1.37 0 01-.14.58.9.9 0 01-.32.4l-3 1.74v13.54a1.36 1.36 0 01-.13.58.91.91 0 01-.33.4l-2.26 1.3a.25.25 0 01-.33 0 .57.57 0 01-.13-.42V81l-3 1.74a.24.24 0 01-.32 0 .56.56 0 01-.14-.42v-2.79a1.34 1.34 0 01.14-.58.9.9 0 01.32-.4z"
                        style={{
                            WebkitTransformOrigin: 108.74,
                            MsTransformOrigin: 108.74,
                            transformOrigin: 108.74,
                        }}
                        id="eli46af5esmg"
                        fill="#BA68C8"
                        className="animable"
                    ></path>
                    <path
                        d="M120.46 69.12c.23-.13.41-.13.53 0a.91.91 0 01.24.44L125 84a1.48 1.48 0 01.06.36 1 1 0 01-.11.47.7.7 0 01-.26.33l-2.16 1.24c-.23.14-.39.16-.49.06a.67.67 0 01-.18-.33l-.48-1.91-4.55 2.63-.48 2.46a1.71 1.71 0 01-.18.54 1.14 1.14 0 01-.49.51l-2.15 1.24a.2.2 0 01-.27 0 .46.46 0 01-.11-.34 2.08 2.08 0 01.07-.44l3.7-18.82a4 4 0 01.25-.73 1.25 1.25 0 01.52-.59zm-2.77 13.12l2.77-1.6-1.38-5.53z"
                        style={{
                            WebkitTransformOrigin: 119.104,
                            MsTransformOrigin: 119.104,
                            transformOrigin: 119.104,
                        }}
                        id="elvq0r1338us"
                        fill="#BA68C8"
                        className="animable"
                    ></path>
                    <path
                        d="M134.81 75.07a.25.25 0 01.32 0 .54.54 0 01.14.43v2.79a1.24 1.24 0 01-.14.58.9.9 0 01-.32.4l-7.93 4.57a.23.23 0 01-.32 0 .57.57 0 01-.14-.42v-17a1.41 1.41 0 01.14-.58 1 1 0 01.32-.4l2.25-1.29a.25.25 0 01.32 0 .57.57 0 01.14.42v13.52z"
                        style={{
                            WebkitTransformOrigin: 130.846,
                            MsTransformOrigin: 130.846,
                            transformOrigin: 130.846,
                        }}
                        id="el1c3r1rksgadh"
                        fill="#BA68C8"
                        className="animable"
                    ></path>
                </g>
            </g>
            <g
                id="freepik--Characters--inject-2"
                style={{
                    WebkitTransformOrigin: 293.169,
                    MsTransformOrigin: 293.169,
                    transformOrigin: 293.169,
                }}
                className="animable"
            >
                <g
                    id="freepik--characters--inject-2"
                    style={{
                        WebkitTransformOrigin: 293.169,
                        MsTransformOrigin: 293.169,
                        transformOrigin: 293.169,
                    }}
                    className="animable"
                >
                    <g
                        id="freepik--wheel-chair--inject-2"
                        style={{
                            WebkitTransformOrigin: 293.169,
                            MsTransformOrigin: 293.169,
                            transformOrigin: 293.169,
                        }}
                        className="animable"
                    >
                        <path
                            d="M339.17 259.36l-2.57-1.63c-6.34-4-12.41-6-17.86-6.33h-.48a24.17 24.17 0 00-2.83.06 31 31 0 00-21.63 11l-.31.35a7.93 7.93 0 00-.53.65l-.34.45c-.15.18-.29.37-.42.55-.25.37-.5.73-.74 1.11l-.25.41c-.12.18-.22.37-.33.56v.07a30.86 30.86 0 00-4.3 14.63l-.05 1.24c0 .56-.07 1.14-.1 1.72l-.12 3c-1 26.37 16.23 59.16 38.55 73.23l2.58 1.63c6.34 4 12.4 6 17.86 6.33h3.41a31 31 0 0022.13-11.7c.23-.28.45-.57.67-.86l.08-.11c.25-.34.5-.69.73-1.05a30.8 30.8 0 005.21-16l.11-3 .12-3.05c.99-26.4-16.26-59.19-38.59-73.26zm-12.71 92.94c-18.84-11.89-33.42-39.57-32.55-61.83s16.85-30.68 35.7-18.79 33.39 39.56 32.55 61.82-16.86 30.68-35.7 18.8z"
                            style={{
                                WebkitTransformOrigin: 332.035,
                                MsTransformOrigin: 332.035,
                                transformOrigin: 332.035,
                            }}
                            id="elovt2l99bdc"
                            fill="#455A64"
                            className="animable"
                        ></path>
                        <path
                            d="M331.25 263.54l-2.58-1.63c-11-7-21.25-8-28.88-4.16-.2.1-.39.2-.59.32l-.14.08-.69.4c-.22.14-.45.28-.67.44a12.44 12.44 0 00-1.29.94l-.61.51c-.41.35-.81.72-1.19 1.11q-.3.3-.57.6l-.55.62a7.93 7.93 0 00-.53.65l-.34.45c-.15.18-.29.37-.42.55-.25.37-.5.73-.74 1.11l-.25.41c-.12.18-.22.37-.33.56l-.31.57c-.37.68-.72 1.39-1 2.14-.18.39-.35.79-.5 1.19v.05c-.28.73-.54 1.5-.78 2.28a33.56 33.56 0 00-.75 2.81c-.05.24-.11.49-.16.73-.09.42-.16.85-.24 1.27s-.16.95-.23 1.45v.24c-.06.42-.11.83-.16 1.26 0 .17 0 .35-.05.52 0 .46-.09.94-.12 1.43s-.07 1.14-.1 1.72l-.12 3c-1 26.37 16.23 59.16 38.55 73.23l2.58 1.63c6.49 4.09 12.68 6.14 18.24 6.36h2.79c.31 0 .61-.05.91-.09l.81-.11.78-.13c.5-.1 1-.21 1.47-.35l.61-.17a6.37 6.37 0 00.66-.21l.57-.21a11 11 0 001.19-.49 5.15 5.15 0 00.59-.27l.15-.08a1.27 1.27 0 00.23-.12l.37-.18c7.51-4.1 12.4-13.12 12.91-26.16l.11-3.05c.94-26.37-16.32-59.15-38.63-73.22zm-4.79 88.76c-18.84-11.89-33.42-39.57-32.55-61.83s16.85-30.68 35.7-18.79 33.39 39.56 32.55 61.82-16.86 30.68-35.7 18.8z"
                            style={{
                                WebkitTransformOrigin: 328.118,
                                MsTransformOrigin: 328.118,
                                transformOrigin: 328.118,
                            }}
                            id="el8sbr62qooww"
                            fill="#263238"
                            className="animable"
                        ></path>
                        <path
                            d="M352.65 347.6c-5.78 6.35-15.38 6.92-26 .22-16.76-10.56-29.71-35.17-28.94-55 .35-8.84 3.38-15.23 8.12-18.65-3.35 3.67-5.44 9.26-5.72 16.5-.77 19.79 12.18 44.39 28.93 55 9.25 5.84 17.74 6.17 23.61 1.93z"
                            style={{
                                WebkitTransformOrigin: 325.164,
                                MsTransformOrigin: 325.164,
                                transformOrigin: 325.164,
                            }}
                            id="el8yup42dz07w"
                            fill="#BA68C8"
                            className="animable"
                        ></path>
                        <path
                            d="M352.65 347.6c-5.78 6.35-15.38 6.92-26 .22-16.76-10.56-29.71-35.17-28.94-55 .35-8.84 3.38-15.23 8.12-18.65-3.35 3.67-5.44 9.26-5.72 16.5-.77 19.79 12.18 44.39 28.93 55 9.25 5.84 17.74 6.17 23.61 1.93z"
                            style={{
                                WebkitTransformOrigin: 325.164,
                                MsTransformOrigin: 325.164,
                                transformOrigin: 325.164,
                            }}
                            id="el27mbfhmzifv"
                            className="animable"
                            opacity="0.2"
                        ></path>
                        <path
                            d="M329.61 271.68c-18.85-11.88-34.83-3.47-35.7 18.79s13.7 49.94 32.55 61.83 34.82 3.47 35.69-18.8-13.7-49.94-32.54-61.82zm-3 76.14c-16.75-10.57-29.7-35.17-28.93-55s15-27.27 31.73-16.7 29.71 35.16 28.93 54.95-14.96 27.31-31.71 16.75z"
                            style={{
                                WebkitTransformOrigin: 328.03,
                                MsTransformOrigin: 328.03,
                                transformOrigin: 328.03,
                            }}
                            id="elpsv22s3mikb"
                            fill="#BA68C8"
                            className="animable"
                        ></path>
                        <path
                            d="M357.7 321.23c-.06-.35-.12-.71-.19-1.06l-26.74-8.3-.58-.93 20.31-10.69c-.14-.28-.3-.56-.45-.84l-20.31 10.69-.43-1 8.21-26.48-.77-.74-8.08 26.05-.91-1.13-5.62-34.17-1-.31 5.54 33.7-1.08-.2-17.36-33-.86.43 17.37 33-.44 1-24.91-23.89c-.11.33-.23.67-.33 1l25.27 24.23.41 1.39-26.51-8.23c0 .35.1.7.16 1.05l26.95 8.37.58.92L305.2 323l.44.85L326.36 313l.44 1-8.45 27.22.77.75 8.31-26.79.91 1.12 5.78 35.16 1 .3-5.68-34.76 1.08.2 17.75 33.8c.28-.14.56-.3.83-.46l-17.73-33.74.44-1 25.11 24.08c.11-.34.21-.69.3-1l-25.43-24.39-.41-1.39z"
                            style={{
                                WebkitTransformOrigin: 327.97,
                                MsTransformOrigin: 327.97,
                                transformOrigin: 327.97,
                            }}
                            id="elx45ancku6cf"
                            fill="#EBEBEB"
                            className="animable"
                        ></path>
                        <path
                            d="M330.39 297.61c-3.23-2-6.19-2.27-8.36-1-.45.26-1 .48-1.57.79a4.34 4.34 0 00-.46.28h-.08a6 6 0 00-.59.44l-.12.12a4.45 4.45 0 00-.48.49c-.06.06-.11.13-.17.2s-.26.34-.38.52l-.18.31c-.1.17-.2.34-.29.52s-.13.29-.19.43-.14.34-.21.53-.11.37-.16.56-.1.33-.14.5-.1.5-.14.76-.06.28-.07.43a10.5 10.5 0 00-.11 1.29c-.29 7.41 4.57 16.64 10.85 20.61q.58.36 1.17.66a6.71 6.71 0 00.68.3l.46.21.47.15.65.21.26.05c.28.06.56.12.83.15h.05a6.11 6.11 0 003.83-.74c.58-.31 1.09-.54 1.74-.89 2.09-1.16 3.45-3.69 3.6-7.32.26-7.37-4.61-16.6-10.89-20.56zm-4.19 22.23c-1.94-1.64-4.55-6.45-5.55-9.12a21.47 21.47 0 002 1.32c3 1.68 3-.44 4.15 1.08s.79 5.12-.24 6.95a1.75 1.75 0 01-.36-.23zm6.44-13.56a3 3 0 00-.51.21l-1.82.94a2.24 2.24 0 00-.93.86c-1.44-1.59-3-6.53-2.76-8.82 2.57 1 6.76 4.78 7.38 6.2a2.19 2.19 0 01.11.34 7.39 7.39 0 00-1.47.27zm-8.78-1.88c.84 3.55 2.3 4.15 2.35 5.3-2.28-.46-5.91-2.83-6.08-5.05a8.88 8.88 0 012.25-5.82c.95.46.8 2.66 1.48 5.57zm5.86 18.7c-1.17-1.15.22-2.18.93-4.45a6.25 6.25 0 00.1-3.33c2.31 2 5.69 7.05 4.71 8.48a1.49 1.49 0 01-.12.14c-2.02.44-4.8-.02-5.62-.84zm6-7.42c-2.39-3.48-3.44-2.36-4-4.19a2.31 2.31 0 01.91-2.39 3 3 0 013.62 1.38c1.15 2.24 1.68 6.26 1.64 8.75-.57-.93-1.27-2.23-2.19-3.55z"
                            style={{
                                WebkitTransformOrigin: 328.984,
                                MsTransformOrigin: 328.984,
                                transformOrigin: 328.984,
                            }}
                            id="ellmbrjaph38f"
                            fill="#E0E0E0"
                            className="animable"
                        ></path>
                        <path
                            d="M330.39 297.61c-3.23-2-6.19-2.27-8.36-1-.45.26-1 .48-1.57.79a4.34 4.34 0 00-.46.28h-.08a6 6 0 00-.59.44l-.12.12a4.45 4.45 0 00-.48.49c-.06.06-.11.13-.17.2s-.26.34-.38.52l-.18.31c-.1.17-.2.34-.29.52s-.13.29-.19.43-.14.34-.21.53-.11.37-.16.56-.1.33-.14.5-.1.5-.14.76-.06.28-.07.43a10.5 10.5 0 00-.11 1.29c-.29 7.41 4.57 16.64 10.85 20.61q.58.36 1.17.66a6.71 6.71 0 00.68.3l.46.21.47.15.65.21.26.05c.28.06.56.12.83.15h.05a6.11 6.11 0 003.83-.74c.58-.31 1.09-.54 1.74-.89 2.09-1.16 3.45-3.69 3.6-7.32.26-7.37-4.61-16.6-10.89-20.56zm-4.19 22.23c-1.94-1.64-4.55-6.45-5.55-9.12a21.47 21.47 0 002 1.32c3 1.68 3-.44 4.15 1.08s.79 5.12-.24 6.95a1.75 1.75 0 01-.36-.23zm6.44-13.56a3 3 0 00-.51.21l-1.82.94a2.24 2.24 0 00-.93.86c-1.44-1.59-3-6.53-2.76-8.82 2.57 1 6.76 4.78 7.38 6.2a2.19 2.19 0 01.11.34 7.39 7.39 0 00-1.47.27zm-8.78-1.88c.84 3.55 2.3 4.15 2.35 5.3-2.28-.46-5.91-2.83-6.08-5.05a8.88 8.88 0 012.25-5.82c.95.46.8 2.66 1.48 5.57zm5.86 18.7c-1.17-1.15.22-2.18.93-4.45a6.25 6.25 0 00.1-3.33c2.31 2 5.69 7.05 4.71 8.48a1.49 1.49 0 01-.12.14c-2.02.44-4.8-.02-5.62-.84zm6-7.42c-2.39-3.48-3.44-2.36-4-4.19a2.31 2.31 0 01.91-2.39 3 3 0 013.62 1.38c1.15 2.24 1.68 6.26 1.64 8.75-.57-.93-1.27-2.23-2.19-3.55z"
                            style={{
                                WebkitTransformOrigin: 328.984,
                                MsTransformOrigin: 328.984,
                                transformOrigin: 328.984,
                            }}
                            id="elfbzmzsuj62d"
                            className="animable"
                            opacity="0.2"
                        ></path>
                        <path
                            d="M328.56 298.55c-6.28-4-11.61-1.15-11.9 6.27s4.57 16.64 10.85 20.61 11.6 1.15 11.89-6.27-4.56-16.65-10.84-20.61zm-2.92.68c2.3.12 7.66 4.82 8.36 6.44s-1.3 1-3.18 1.55c-2.39.74-1.36 3.07-2.72 2.44-1.99-.92-4.75-10.56-2.46-10.43zm-3.45-.49c1.18.25.94 2.56 1.67 5.66.93 3.93 2.61 4.24 2.32 5.68-.44 2.12-7.64-1.35-7.87-4.49s2.69-7.11 3.88-6.85zm2.18 22c-2.43-2-6-9.21-5.95-10.68s1.89.63 4.22 2c3 1.68 3-.44 4.15 1.08 1.73 2.2.03 9.7-2.42 7.63zm11.09 3c-1.28 1.86-6.39 1.4-7.56.25s.23-2.19.94-4.46c.89-2.88-.77-4.52.25-5 1.49-.7 7.65 7.4 6.37 9.27zm-1.57-7.19c-2.4-3.47-3.45-2.35-4-4.18-.8-2.67 4.7-5.16 6.35-1.95s2 10.09 1.28 10.84-1.74-1.92-3.63-4.65z"
                            style={{
                                WebkitTransformOrigin: 328.03,
                                MsTransformOrigin: 328.03,
                                transformOrigin: 328.03,
                            }}
                            id="elx8ydwjiochj"
                            fill="#E0E0E0"
                            className="animable"
                        ></path>
                        <path
                            d="M327.87 316.1c1.92 1.21 3.55.35 3.64-1.92a7.87 7.87 0 00-3.32-6.3c-1.92-1.21-3.55-.36-3.64 1.91a7.91 7.91 0 003.32 6.31z"
                            style={{
                                WebkitTransformOrigin: 328.03,
                                MsTransformOrigin: 328.03,
                                transformOrigin: 328.03,
                            }}
                            id="el68fwid3d3iu"
                            fill="#455A64"
                            className="animable"
                        ></path>
                        <path
                            d="M425 397.24l-12.59-29.47-4-9.41A35.39 35.39 0 00395.78 343l-.16 4.09a32.06 32.06 0 019.64 12.58l1.92 4.49-10.35-6.42-.15 3.9 12.82 7.95 12.36 28.95a1.68 1.68 0 001.5 1 1.69 1.69 0 001.62-2.36z"
                            style={{
                                WebkitTransformOrigin: 410.37,
                                MsTransformOrigin: 410.37,
                                transformOrigin: 410.37,
                            }}
                            id="el7s86tmqix44"
                            fill="#FAFAFA"
                            className="animable"
                        ></path>
                        <path
                            d="M388.08 355.1c-5.15 8.88-4 20.49-4 24.44s-1.93 3.11-2.92-.11-3.44-16.29 2-27.4z"
                            style={{
                                WebkitTransformOrigin: 383.913,
                                MsTransformOrigin: 383.913,
                                transformOrigin: 383.913,
                            }}
                            id="el8ceaqd4adih"
                            fill="#EBEBEB"
                            className="animable"
                        ></path>
                        <path
                            d="M396.17 383.65c.29-7.29-4.49-16.36-10.66-20.25-3.24-2-6.21-2.24-8.35-.92l-5 2.56 15.31 28.5 4.93-2.54c2.18-1.11 3.6-3.63 3.77-7.35z"
                            style={{
                                WebkitTransformOrigin: 384.171,
                                MsTransformOrigin: 384.171,
                                transformOrigin: 384.171,
                            }}
                            id="el1zihj3agf3n"
                            fill="#455A64"
                            className="animable"
                        ></path>
                        <path
                            d="M380.23 366.16c6.17 3.89 10.94 13 10.66 20.25s-5.52 10-11.7 6.15-10.94-13-10.66-20.25 5.52-10.05 11.7-6.15z"
                            style={{
                                WebkitTransformOrigin: 379.71,
                                MsTransformOrigin: 379.71,
                                transformOrigin: 379.71,
                            }}
                            id="elpx9m6uvf15"
                            fill="#263238"
                            className="animable"
                        ></path>
                        <path
                            id="elokp9cit6zl"
                            d="M379.89 374.71a8.91 8.91 0 013.75 7.13c-.1 2.57-1.94 3.54-4.11 2.17a8.89 8.89 0 01-3.76-7.13c.1-2.57 1.95-3.54 4.12-2.17z"
                            style={{
                                WebkitTransformOrigin: 379.705,
                                MsTransformOrigin: 379.705,
                                transformOrigin: 379.705,
                            }}
                            className="animable"
                        ></path>
                        <path
                            d="M384.71 354.59c-5.15 8.88-4 20.49-4 24.45s-1.92 3.1-2.91-.12-3.44-16.28 2-27.4z"
                            style={{
                                WebkitTransformOrigin: 380.548,
                                MsTransformOrigin: 380.548,
                                transformOrigin: 380.548,
                            }}
                            id="elsk5ngagc6w"
                            fill="#FAFAFA"
                            className="animable"
                        ></path>
                        <path
                            d="M396.67 359.56l-46.76-30.28-.2 5.06 39.86 25.73 5.13 3.3.9.57a2.33 2.33 0 003.58-2.1l-.25-4.61z"
                            style={{
                                WebkitTransformOrigin: 374.447,
                                MsTransformOrigin: 374.447,
                                transformOrigin: 374.447,
                            }}
                            id="eldqqwtekywkl"
                            fill="#37474F"
                            className="animable"
                        ></path>
                        <path
                            style={{
                                WebkitTransformOrigin: 387.14,
                                MsTransformOrigin: 387.14,
                                transformOrigin: 387.14,
                            }}
                            id="elqkmxhfmgyrs"
                            fill="#BA68C8"
                            d="M360.81 442.44L338.38 428.29 413.46 388.75 435.9 402.9 360.81 442.44z"
                            className="animable"
                        ></path>
                        <path
                            style={{
                                WebkitTransformOrigin: 349.495,
                                MsTransformOrigin: 349.495,
                                transformOrigin: 349.495,
                            }}
                            id="el73401ltfy2n"
                            fill="#BA68C8"
                            d="M338.38 428.29L338.18 433.59 360.61 447.74 360.81 442.44 338.38 428.29z"
                            className="animable"
                        ></path>
                        <path
                            style={{
                                WebkitTransformOrigin: 349.495,
                                MsTransformOrigin: 349.495,
                                transformOrigin: 349.495,
                            }}
                            id="el9sk49ou4o3k"
                            d="M338.38 428.29L338.18 433.59 360.61 447.74 360.81 442.44 338.38 428.29z"
                            className="animable"
                            opacity="0.3"
                        ></path>
                        <path
                            style={{
                                WebkitTransformOrigin: 398.255,
                                MsTransformOrigin: 398.255,
                                transformOrigin: 398.255,
                            }}
                            id="elqmtzksr7sk"
                            fill="#BA68C8"
                            d="M435.9 402.9L435.7 408.2 360.61 447.74 360.81 442.44 435.9 402.9z"
                            className="animable"
                        ></path>
                        <path
                            style={{
                                WebkitTransformOrigin: 398.255,
                                MsTransformOrigin: 398.255,
                                transformOrigin: 398.255,
                            }}
                            id="elurc1oz4r67"
                            d="M435.9 402.9L435.7 408.2 360.61 447.74 360.81 442.44 435.9 402.9z"
                            className="animable"
                            opacity="0.15"
                        ></path>
                        <path
                            d="M309.91 377.75a1.7 1.7 0 012.34-.53l1.41.89a35.38 35.38 0 0113.72 16.1l4 9.4L344 433.09a1.69 1.69 0 01-1.63 2.36 1.69 1.69 0 01-1.49-1l-12.38-28.98-16.56-10.28a1.69 1.69 0 111.78-2.88l12.46 7.69-1.92-4.5a31.94 31.94 0 00-12.41-14.5l-1.41-.89a1.7 1.7 0 01-.53-2.36z"
                            style={{
                                WebkitTransformOrigin: 326.89,
                                MsTransformOrigin: 326.89,
                                transformOrigin: 326.89,
                            }}
                            id="ela9pj78cr7lg"
                            fill="#F5F5F5"
                            className="animable"
                        ></path>
                        <path
                            d="M308.31 396.85c-5.15 8.88-4 20.5-4 24.45s-1.93 3.1-2.92-.12-3.44-16.28 2-27.4z"
                            style={{
                                WebkitTransformOrigin: 304.143,
                                MsTransformOrigin: 304.143,
                                transformOrigin: 304.143,
                            }}
                            id="elildgblc9ay"
                            fill="#E0E0E0"
                            className="animable"
                        ></path>
                        <path
                            d="M316.4 425.4c.29-7.29-4.49-16.36-10.66-20.25-3.24-2-6.21-2.23-8.35-.92l-5 2.56 15.32 28.51 4.91-2.56c2.19-1.1 3.64-3.62 3.78-7.34z"
                            style={{
                                WebkitTransformOrigin: 304.401,
                                MsTransformOrigin: 304.401,
                                transformOrigin: 304.401,
                            }}
                            id="el9t6dp4hm3ci"
                            fill="#455A64"
                            className="animable"
                        ></path>
                        <path
                            d="M300.45 407.91c6.18 3.89 10.95 13 10.66 20.25s-5.51 10-11.69 6.15-10.94-12.95-10.66-20.25 5.52-10.06 11.69-6.15z"
                            style={{
                                WebkitTransformOrigin: 299.935,
                                MsTransformOrigin: 299.935,
                                transformOrigin: 299.935,
                            }}
                            id="elb6y1dieqfbt"
                            fill="#37474F"
                            className="animable"
                        ></path>
                        <path
                            d="M300.12 416.46a8.92 8.92 0 013.75 7.13c-.1 2.57-1.94 3.54-4.11 2.17a8.89 8.89 0 01-3.76-7.13c.1-2.57 2-3.54 4.12-2.17z"
                            style={{
                                WebkitTransformOrigin: 299.935,
                                MsTransformOrigin: 299.935,
                                transformOrigin: 299.935,
                            }}
                            id="elawf15sjf0nl"
                            fill="#263238"
                            className="animable"
                        ></path>
                        <path
                            d="M304.94 396.34c-5.15 8.88-4.05 20.5-4 24.45s-1.92 3.1-2.91-.12-3.45-16.28 2-27.4z"
                            style={{
                                WebkitTransformOrigin: 300.776,
                                MsTransformOrigin: 300.776,
                                transformOrigin: 300.776,
                            }}
                            id="el4vdmm1n8mzf"
                            fill="#F5F5F5"
                            className="animable"
                        ></path>
                        <g
                            id="freepik--Chartacter--inject-2"
                            style={{
                                WebkitTransformOrigin: 219.861,
                                MsTransformOrigin: 219.861,
                                transformOrigin: 219.861,
                            }}
                            className="animable"
                        >
                            <g
                                id="freepik--Bottom--inject-2"
                                style={{
                                    WebkitTransformOrigin: 211.364,
                                    MsTransformOrigin: 211.364,
                                    transformOrigin: 211.364,
                                }}
                                className="animable"
                            >
                                <path
                                    d="M271.08 375.77c.33 0 .6 3.36-1.28 4.64-2.17 1.48-8.39 3.73-16.32 2.24s-12.09-4-15.12-6.68-7.28-6.4-10.85-7.37c-3.31-.9-6.86-2.53-7.87-3.55s-.57-5.21-.57-5.21z"
                                    style={{
                                        WebkitTransformOrigin: 245.145,
                                        MsTransformOrigin: 245.145,
                                        transformOrigin: 245.145,
                                    }}
                                    id="el2ivz2o6ygdd"
                                    fill="#455A64"
                                    className="animable"
                                ></path>
                                <path
                                    d="M223.34 343.87a1.26 1.26 0 00-1.27.9c-.33 1.14-.82 4.5-1.48 6.36-.91 2.6-1.77 8-1.47 10.16s5.66 4 9.08 5.51a45.46 45.46 0 0110.88 7.28c3.56 3.08 11.26 6.55 16.47 6.87 6.16.37 13.22-1 15-3.47 2.18-3.09 3.87-6.74-5-11.21-1.68-.85-7.53-4.54-9.52-5.86-5.39-3.6-9.13-6.81-11.32-12.67a3.18 3.18 0 00-1.19-1.83 3.22 3.22 0 00-1.77-.27c-1.53.1-7.65.45-9.08 1-1.26.45-3 .95-3.12 2.38a4.42 4.42 0 00.25 1.48c.09.3.15.69-.14.85s-.62-.07-.84-.28a20.88 20.88 0 01-2.28-2.86 8.42 8.42 0 00-1.36-1.44 14.69 14.69 0 01-1.5-1c-.53-.61-.35-1.23-.34-1.9z"
                                    style={{
                                        WebkitTransformOrigin: 245.675,
                                        MsTransformOrigin: 245.675,
                                        transformOrigin: 245.675,
                                    }}
                                    id="elnwp7swlntpq"
                                    fill="#BA68C8"
                                    className="animable"
                                ></path>
                                <path
                                    d="M223.34 343.87a1.26 1.26 0 00-1.27.9c-.33 1.14-.82 4.5-1.48 6.36-.91 2.6-1.77 8-1.47 10.16s5.66 4 9.08 5.51a45.46 45.46 0 0110.88 7.28c3.56 3.08 11.26 6.55 16.47 6.87 6.16.37 13.22-1 15-3.47 2.18-3.09 3.87-6.74-5-11.21-1.68-.85-7.53-4.54-9.52-5.86-5.39-3.6-9.13-6.81-11.32-12.67a3.18 3.18 0 00-1.19-1.83 3.22 3.22 0 00-1.77-.27c-1.53.1-7.65.45-9.08 1-1.26.45-3 .95-3.12 2.38a4.42 4.42 0 00.25 1.48c.09.3.15.69-.14.85s-.62-.07-.84-.28a20.88 20.88 0 01-2.28-2.86 8.42 8.42 0 00-1.36-1.44 14.69 14.69 0 01-1.5-1c-.53-.61-.35-1.23-.34-1.9z"
                                    style={{
                                        WebkitTransformOrigin: 245.675,
                                        MsTransformOrigin: 245.675,
                                        transformOrigin: 245.675,
                                    }}
                                    id="elxhgulqg7p3i"
                                    fill="#FFF"
                                    className="animable"
                                    opacity="0.9"
                                ></path>
                                <path
                                    d="M239.08 374.08c-1.51-1.3-3.12-2.57-4.75-3.72s10.34 6.68 14.86 4.27c2.92-1.55 1.73-3.76 1.71-4.44s10.17-4.78 12.91-4.89c.73.43 1.34.78 1.73 1 8.87 4.47 7.18 8.12 5 11.21-1.77 2.49-6.93 4.18-14.89 3.65-5.21-.39-13.01-4-16.57-7.08z"
                                    style={{
                                        WebkitTransformOrigin: 253.306,
                                        MsTransformOrigin: 253.306,
                                        transformOrigin: 253.306,
                                    }}
                                    id="elof4b27x77g"
                                    fill="#BA68C8"
                                    className="animable"
                                    opacity="0.8"
                                ></path>
                                <path
                                    d="M239.08 374.08c-1.51-1.3-3.12-2.57-4.75-3.72s10.34 6.68 14.86 4.27c2.92-1.55 1.73-3.76 1.71-4.44s10.17-4.78 12.91-4.89c.73.43 1.34.78 1.73 1 8.87 4.47 7.18 8.12 5 11.21-1.77 2.49-6.93 4.18-14.89 3.65-5.21-.39-13.01-4-16.57-7.08z"
                                    style={{
                                        WebkitTransformOrigin: 253.306,
                                        MsTransformOrigin: 253.306,
                                        transformOrigin: 253.306,
                                    }}
                                    id="elfrth5az8alq"
                                    fill="#FFF"
                                    className="animable"
                                    opacity="0.8"
                                ></path>
                                <path
                                    d="M250.28 368.16c5.54 2.46 3.05 3.26 1.45 3.36s-10.82-5.64-16.37-10.24c-5.78-4.79-9.29-9.85-11.44-11.61-.8-.66-1.66-1.46-2.42-2.2.23-1.13.42-2.16.57-2.7a1.26 1.26 0 011.27-.9c0 .67-.19 1.29.33 1.83a14.69 14.69 0 001.5 1 8.42 8.42 0 011.36 1.44 20.88 20.88 0 002.28 2.86c4.57 6.1 15.93 14.71 21.47 17.16z"
                                    style={{
                                        WebkitTransformOrigin: 237.598,
                                        MsTransformOrigin: 237.598,
                                        transformOrigin: 237.598,
                                    }}
                                    id="elm4vquus4j9"
                                    fill="#BA68C8"
                                    className="animable"
                                ></path>
                                <path
                                    d="M251.37 370.73a.57.57 0 01-.34-.14.47.47 0 010-.72c1.72-1.69 9.6-5.42 13.75-4.72a.52.52 0 01.46.6.53.53 0 01-.65.41c-3.87-.64-11.37 3.08-12.74 4.41a.57.57 0 01-.48.16z"
                                    style={{
                                        WebkitTransformOrigin: 258.054,
                                        MsTransformOrigin: 258.054,
                                        transformOrigin: 258.054,
                                    }}
                                    id="elfl6wg9z2hhi"
                                    fill="#FAFAFA"
                                    className="animable"
                                ></path>
                                <path
                                    d="M246.61 367.62a.64.64 0 01-.35-.14.49.49 0 010-.73c1.72-1.68 9.6-5.41 13.76-4.71a.53.53 0 01.46.6.55.55 0 01-.65.41c-3.88-.64-11.38 3.08-12.74 4.41a.62.62 0 01-.48.16z"
                                    style={{
                                        WebkitTransformOrigin: 253.291,
                                        MsTransformOrigin: 253.291,
                                        transformOrigin: 253.291,
                                    }}
                                    id="el0yivngia6lpg"
                                    fill="#FAFAFA"
                                    className="animable"
                                ></path>
                                <path
                                    d="M241.83 364.65a.67.67 0 01-.35-.14.49.49 0 010-.73c1.73-1.68 9.61-5.41 13.76-4.71a.53.53 0 01.46.6.54.54 0 01-.65.41c-3.88-.64-11.38 3.08-12.74 4.41a.58.58 0 01-.48.16z"
                                    style={{
                                        WebkitTransformOrigin: 248.511,
                                        MsTransformOrigin: 248.511,
                                        transformOrigin: 248.511,
                                    }}
                                    id="elvnnobjyb1s9"
                                    fill="#FAFAFA"
                                    className="animable"
                                ></path>
                                <path
                                    d="M237.44 361.33a.54.54 0 01-.34-.14.48.48 0 010-.72c1.73-1.68 9.63-5.41 13.76-4.71a.52.52 0 01.46.59.55.55 0 01-.65.42c-3.87-.65-11.37 3.07-12.74 4.4a.57.57 0 01-.49.16z"
                                    style={{
                                        WebkitTransformOrigin: 244.131,
                                        MsTransformOrigin: 244.131,
                                        transformOrigin: 244.131,
                                    }}
                                    id="el9udni8ulp85"
                                    fill="#FAFAFA"
                                    className="animable"
                                ></path>
                                <path
                                    d="M233.15 358a.59.59 0 01-.34-.13.49.49 0 01-.05-.73c2.38-2.39 10.57-5.39 14.72-4.7a.53.53 0 01.46.6.54.54 0 01-.65.41c-3.73-.62-11.58 2.27-13.69 4.39a.58.58 0 01-.45.16z"
                                    style={{
                                        WebkitTransformOrigin: 240.283,
                                        MsTransformOrigin: 240.283,
                                        transformOrigin: 240.283,
                                    }}
                                    id="eln8p2fli8o"
                                    fill="#FAFAFA"
                                    className="animable"
                                ></path>
                                <path
                                    d="M176.32 386.08c-.83 4.76-2.11 7.82-4.59 10.32s-6.71 2.79-10.83 1.35-9.3-4.44-10.09-8.77-.28-7.15 1.11-11.48z"
                                    style={{
                                        WebkitTransformOrigin: 163.379,
                                        MsTransformOrigin: 163.379,
                                        transformOrigin: 163.379,
                                    }}
                                    id="elv0jcucj19d"
                                    fill="#455A64"
                                    className="animable"
                                ></path>
                                <path
                                    d="M163 348.74c-1.74-.15-2.88 6.25-4.52 12.58-1.75 6.79-4.7 9.27-6.21 14.83-1.73 6.34-1.58 9.31 1 13.68s12.55 9.73 18.22 4.84c4.62-4 5.3-9.05 5.55-15.6.27-6.77.38-11.55 1.24-16.59.81-4.82 1.71-9.48.26-10.24-.19.7-.39 1.59-.58 2.27s-.58 3.14-1.56 3a8.05 8.05 0 01.17-1.83 1.85 1.85 0 00-.33-1.64 3.85 3.85 0 00-1.85-.95c-1.68-.51-3.37-1-5.09-1.37a32.7 32.7 0 00-2.59-.47 8.72 8.72 0 00-2.22-.07 1.4 1.4 0 00-1 .52 1.53 1.53 0 00-.16.73 4.47 4.47 0 01-.35 1.3c-.08.19-.28.4-.52.31a.4.4 0 01-.25-.43c.08-.79.26-1.34.4-2.24.06-.42.2-1 .25-1.41s.08-.81.14-1.22z"
                                    style={{
                                        WebkitTransformOrigin: 165.217,
                                        MsTransformOrigin: 165.217,
                                        transformOrigin: 165.217,
                                    }}
                                    id="el94q088w6rn"
                                    fill="#BA68C8"
                                    className="animable"
                                ></path>
                                <path
                                    d="M163 348.74c-1.74-.15-2.88 6.25-4.52 12.58-1.75 6.79-4.7 9.27-6.21 14.83-1.73 6.34-1.58 9.31 1 13.68s12.55 9.73 18.22 4.84c4.62-4 5.3-9.05 5.55-15.6.27-6.77.38-11.55 1.24-16.59.81-4.82 1.71-9.48.26-10.24-.19.7-.39 1.59-.58 2.27s-.58 3.14-1.56 3a8.05 8.05 0 01.17-1.83 1.85 1.85 0 00-.33-1.64 3.85 3.85 0 00-1.85-.95c-1.68-.51-3.37-1-5.09-1.37a32.7 32.7 0 00-2.59-.47 8.72 8.72 0 00-2.22-.07 1.4 1.4 0 00-1 .52 1.53 1.53 0 00-.16.73 4.47 4.47 0 01-.35 1.3c-.08.19-.28.4-.52.31a.4.4 0 01-.25-.43c.08-.79.26-1.34.4-2.24.06-.42.2-1 .25-1.41s.08-.81.14-1.22z"
                                    style={{
                                        WebkitTransformOrigin: 165.217,
                                        MsTransformOrigin: 165.217,
                                        transformOrigin: 165.217,
                                    }}
                                    id="elk7czxps00im"
                                    fill="#FFF"
                                    className="animable"
                                    opacity="0.9"
                                ></path>
                                <path
                                    d="M152.85 374.35c-.26.92-1.89 7 .18 8.42 2.24 1.56 4-3.14 4-3.14s5.65-.51 13.43 3.4c-.51 1 .4 4.45 2.68 4.07s3.83-7.38 3.85-7.47c-.28 6.28-1 11.17-5.53 15-5.67 4.89-15.67-.48-18.22-4.84s-2.7-7.34-1-13.68c.21-.6.4-1.19.61-1.76z"
                                    style={{
                                        WebkitTransformOrigin: 164.053,
                                        MsTransformOrigin: 164.053,
                                        transformOrigin: 164.053,
                                    }}
                                    id="elnt6bxdtnxxh"
                                    fill="#BA68C8"
                                    className="animable"
                                ></path>
                                <path
                                    d="M152.85 374.35c-.26.92-1.89 7 .18 8.42 2.24 1.56 4-3.14 4-3.14s5.65-.51 13.43 3.4c-.51 1 .4 4.45 2.68 4.07s3.83-7.38 3.85-7.47c-.28 6.28-1 11.17-5.53 15-5.67 4.89-15.67-.48-18.22-4.84s-2.7-7.34-1-13.68c.21-.6.4-1.19.61-1.76z"
                                    style={{
                                        WebkitTransformOrigin: 164.053,
                                        MsTransformOrigin: 164.053,
                                        transformOrigin: 164.053,
                                    }}
                                    id="elafvpj49dvx5"
                                    fill="#FFF"
                                    className="animable"
                                    opacity="0.8"
                                ></path>
                                <path
                                    d="M157.63 380.14c-.27 2.35-3.18 1.12-3-2.22s3.3-10.88 3.84-16.6c1.64-6.33 2.78-12.73 4.52-12.58v.24l-.55 3.25a12.38 12.38 0 00-.24 1.4c-.51 4.79-2.29 13.93-3.25 18.24a58.78 58.78 0 00-1.32 8.27z"
                                    style={{
                                        WebkitTransformOrigin: 158.806,
                                        MsTransformOrigin: 158.806,
                                        transformOrigin: 158.806,
                                    }}
                                    id="elqynmdo0wm0a"
                                    fill="#BA68C8"
                                    className="animable"
                                ></path>
                                <path
                                    d="M169.54 382.83a58.86 58.86 0 002.46-8c1-4.26 3.42-13.15 5.07-17.72a9.65 9.65 0 00.87-2.59c.18-.64.36-1.45.54-2.12v-.15c1 .57.86 3.18.37 6.41-.4 1.85-1 4.12-1.84 6.86-2 5.38-2.54 13.55-3.84 16.64s-4.42 2.9-3.63.67z"
                                    style={{
                                        WebkitTransformOrigin: 174.32,
                                        MsTransformOrigin: 174.32,
                                        transformOrigin: 174.32,
                                    }}
                                    id="elyz528zspcho"
                                    fill="#BA68C8"
                                    className="animable"
                                ></path>
                                <path
                                    d="M170.62 383.24a.7.7 0 01-.23-.08 26.47 26.47 0 00-13.23-3 .73.73 0 01-.76-.47c-.06-.28.17-.53.52-.55a27.8 27.8 0 0114.16 3.24.46.46 0 01.2.71.66.66 0 01-.66.15z"
                                    style={{
                                        WebkitTransformOrigin: 163.883,
                                        MsTransformOrigin: 163.883,
                                        transformOrigin: 163.883,
                                    }}
                                    id="elfpe2k97cbig"
                                    fill="#FAFAFA"
                                    className="animable"
                                ></path>
                                <path
                                    d="M172.57 378.35a.6.6 0 01-.21-.08 33 33 0 00-14.82-3.37.74.74 0 01-.74-.49c-.05-.28.19-.52.54-.53a34.24 34.24 0 0115.66 3.57c.31.17.42.49.24.71a.66.66 0 01-.67.19z"
                                    style={{
                                        WebkitTransformOrigin: 165.06,
                                        MsTransformOrigin: 165.06,
                                        transformOrigin: 165.06,
                                    }}
                                    id="elu0fpcj85ni"
                                    fill="#FAFAFA"
                                    className="animable"
                                ></path>
                                <path
                                    d="M158.43 370.11a.68.68 0 01-.51-.41c-.09-.28.12-.54.46-.58 8-.91 15.34 3.27 15.65 3.45s.4.5.21.72a.74.74 0 01-.89.08c-.07 0-7.23-4.1-14.64-3.24a.86.86 0 01-.28-.02z"
                                    style={{
                                        WebkitTransformOrigin: 166.119,
                                        MsTransformOrigin: 166.119,
                                        transformOrigin: 166.119,
                                    }}
                                    id="eluidr287d3qf"
                                    fill="#FAFAFA"
                                    className="animable"
                                ></path>
                                <path
                                    d="M159.33 365.6a.67.67 0 01-.51-.4c-.1-.28.1-.54.45-.59a25.67 25.67 0 0116 3.47.46.46 0 01.15.72.76.76 0 01-.9 0 24.54 24.54 0 00-14.88-3.21.86.86 0 01-.31.01z"
                                    style={{
                                        WebkitTransformOrigin: 167.164,
                                        MsTransformOrigin: 167.164,
                                        transformOrigin: 167.164,
                                    }}
                                    id="el8n9ietiy3pe"
                                    fill="#FAFAFA"
                                    className="animable"
                                ></path>
                                <path
                                    d="M160.36 360.54a.67.67 0 01-.51-.4c-.1-.27.1-.54.44-.58 8.23-1.17 15.76 3.42 16.07 3.62a.46.46 0 01.17.71.74.74 0 01-.9.06c-.07-.05-7.34-4.47-15-3.39a.7.7 0 01-.27-.02z"
                                    style={{
                                        WebkitTransformOrigin: 168.229,
                                        MsTransformOrigin: 168.229,
                                        transformOrigin: 168.229,
                                    }}
                                    id="ela1ckb3idzv"
                                    fill="#FAFAFA"
                                    className="animable"
                                ></path>
                                <path
                                    d="M174.94 170c-4.36 44.95-7.63 106.2-7.63 106.2-.38 3.41-2.9 9.23-4.85 26.06-2.06 17.76-4.07 51.05-4.07 51.05s12.32 6.91 22.46 3.73c0 0 10.78-47.21 16.33-68.08 5.24-19.75 13.56-57.21 13.56-57.21l4.55 37.29s-.92 12.82-.7 21.8c.26 10.45 4.22 58.27 4.22 58.27s16.87 7.1 27.48-.73c0 0 3.3-65.7 3.82-78.26 1-24.62.9-72.25.57-104.07z"
                                    style={{
                                        WebkitTransformOrigin: 204.65,
                                        MsTransformOrigin: 204.65,
                                        transformOrigin: 204.65,
                                    }}
                                    id="elf7wpu31gck"
                                    fill="#BA68C8"
                                    className="animable"
                                ></path>
                                <path
                                    d="M174.94 170c-4.36 44.95-7.63 106.2-7.63 106.2-.38 3.41-2.9 9.23-4.85 26.06-2.06 17.76-4.07 51.05-4.07 51.05s12.32 6.91 22.46 3.73c0 0 10.78-47.21 16.33-68.08 5.24-19.75 13.56-57.21 13.56-57.21l4.55 37.29s-.92 12.82-.7 21.8c.26 10.45 4.22 58.27 4.22 58.27s16.87 7.1 27.48-.73c0 0 3.3-65.7 3.82-78.26 1-24.62.9-72.25.57-104.07z"
                                    style={{
                                        WebkitTransformOrigin: 204.65,
                                        MsTransformOrigin: 204.65,
                                        transformOrigin: 204.65,
                                    }}
                                    id="eluq8641fi44d"
                                    fill="#FFF"
                                    className="animable"
                                    opacity="0.3"
                                ></path>
                                <path
                                    d="M210.74 231.77l4.84-24.58s12.25-1.56 18.61-7.07c0 0-4.17 7.36-15.75 10.07l-4.75 21.7 1.6 37.17z"
                                    style={{
                                        WebkitTransformOrigin: 222.465,
                                        MsTransformOrigin: 222.465,
                                        transformOrigin: 222.465,
                                    }}
                                    id="el5px9dqjtnsk"
                                    fill="#BA68C8"
                                    className="animable"
                                    opacity="0.6"
                                ></path>
                            </g>
                            <g
                                id="freepik--Top--inject-2"
                                style={{
                                    WebkitTransformOrigin: 227.142,
                                    MsTransformOrigin: 227.142,
                                    transformOrigin: 227.142,
                                }}
                                className="animable"
                            >
                                <path
                                    d="M239.17 82.24c13.5 3.76 13 11.05 16.19 24.52 2.68 11.43 6.79 27.87 6.79 27.87s9.82 16.36 16.7 27l-14.46 11.2a133.82 133.82 0 01-15.63-14.95c-5.24-6-5.86-6.24-9.2-15.42-2.55-7-7.86-25.8-7.86-25.8z"
                                    style={{
                                        WebkitTransformOrigin: 255.275,
                                        MsTransformOrigin: 255.275,
                                        transformOrigin: 255.275,
                                    }}
                                    id="elzt593seis1m"
                                    fill="#E6E6E6"
                                    className="animable"
                                ></path>
                                <path
                                    d="M268.52 178.94a18.75 18.75 0 00-3.77-6.33c3.25-5.36 7.2-9.61 14.1-11 2.67 4.13 5.59 7.3 7 10.14a35.74 35.74 0 013.29 18.49l-6.08-3.83c-3.81-2.2-7.67 4.37-7.79 7s.63 4.08.13 5.7-2.8 3.21-3.9.78-3.25-5.72-3.45-9.73.95-8.64.47-11.22z"
                                    style={{
                                        WebkitTransformOrigin: 277.017,
                                        MsTransformOrigin: 277.017,
                                        transformOrigin: 277.017,
                                    }}
                                    id="ely5kb61yle"
                                    fill="#FFA8A7"
                                    className="animable"
                                ></path>
                                <path
                                    d="M175.84 87.19s-8 6.38-4.55 22.47c2.7 12.62 3.34 26.31 3.62 31.83.43 8.46-1 34.48-1 34.48 12.5 15.5 70.62 12.59 77.5-1.18 0 0 .51-52.83-4-72-2.55-10.88-5.2-16.72-9.26-19.87l-21.79-3.94-11.92-1.22z"
                                    style={{
                                        WebkitTransformOrigin: 210.927,
                                        MsTransformOrigin: 210.927,
                                        transformOrigin: 210.927,
                                    }}
                                    id="ell4l49em9hns"
                                    fill="#BA68C8"
                                    className="animable"
                                ></path>
                                <path
                                    d="M175.84 87.19s-8 6.38-4.55 22.47c2.7 12.62 3.34 26.31 3.62 31.83.43 8.46-1 34.48-1 34.48 12.5 15.5 70.62 12.59 77.5-1.18 0 0 .51-52.83-4-72-2.55-10.88-5.2-16.72-9.26-19.87l-21.79-3.94-11.92-1.22z"
                                    style={{
                                        WebkitTransformOrigin: 210.927,
                                        MsTransformOrigin: 210.927,
                                        transformOrigin: 210.927,
                                    }}
                                    id="el9zt9wng4qz"
                                    fill="#FFF"
                                    className="animable"
                                    opacity="0.7"
                                ></path>
                                <path
                                    d="M204.43 77.71l-8.91 3a58.54 58.54 0 006.93 12.23c4 5 13.38 12.35 20.72 15.19 3.3-8.34 4.63-14.22 4-20.26a29.25 29.25 0 00-1.61-7.25L216.63 79z"
                                    style={{
                                        WebkitTransformOrigin: 211.421,
                                        MsTransformOrigin: 211.421,
                                        transformOrigin: 211.421,
                                    }}
                                    id="el9qz0sho2oc9"
                                    fill="#455A64"
                                    className="animable"
                                ></path>
                                <path
                                    d="M239.17 82.24l-16.34-4.53-.24 2.59a24.89 24.89 0 019.11 9.26c4.2 7.74 9.56 10.21 10.6 35.54.7 17.05.13 116.29.13 116.29s5 3 9.59.64V147.6c-.02-16.05.35-51.68-12.85-65.36zm-39.87-4.71L175 86.7c-7.42 7.55-5.87 15.52-3.79 32.46s.53 39.75 0 50.05-6.21 72.32-6.21 72.32c7.3 9.12 31.14 7 31.14 7s8.47-125 6.91-141.11-3.75-29.89-3.75-29.89z"
                                    style={{
                                        WebkitTransformOrigin: 208.51,
                                        MsTransformOrigin: 208.51,
                                        transformOrigin: 208.51,
                                    }}
                                    id="elqgnumxsgpan"
                                    fill="#F0F0F0"
                                    className="animable"
                                ></path>
                                <g
                                    id="freepik--Head--inject-2"
                                    style={{
                                        WebkitTransformOrigin: 214.649,
                                        MsTransformOrigin: 214.649,
                                        transformOrigin: 214.649,
                                    }}
                                    className="animable"
                                >
                                    <path
                                        d="M220.68 20.5c-20-1.26-26.77 8.11-29.11 17.37s3.29 22 8.87 30.86L238 44.93c3.94-9.41-2-23.48-17.32-24.43z"
                                        style={{
                                            WebkitTransformOrigin: 215.104,
                                            MsTransformOrigin: 215.104,
                                            transformOrigin: 215.104,
                                        }}
                                        id="el6a75cb4efrk"
                                        fill="#37474F"
                                        className="animable"
                                    ></path>
                                    <path
                                        d="M236.92 67.76c-1.29 4.44-3.92 7.68-8 8.27a30.52 30.52 0 01-5.9 0l-.15 1.65-.24 2.58c3.92 5.44 1.38 9.77-2.7 10.27-7.15.86-15.51-4.07-20-9.29-.35-2.38-.56-3.75-.56-3.75l1.44-14.14s-2 2.37-5.69.89c-2.82-1.14-6.5-6.53-4.37-10.94s6.9-3.49 8.16-2.15 1.53 3.48 3.51 3.2c1.05-.14 2.11-1.78 1.86-5.44 2.45-3.15 3.32-6 2.64-11.32 9.76-6 26.35-4.81 30.92-1.18 1.7 7.23 1.16 24.2-.92 31.35z"
                                        style={{
                                            WebkitTransformOrigin: 214.482,
                                            MsTransformOrigin: 214.482,
                                            transformOrigin: 214.482,
                                        }}
                                        id="ely7s0ulwp3tb"
                                        fill="#FFA8A7"
                                        className="animable"
                                    ></path>
                                    <path
                                        d="M223 76.06c-6.56-.72-15.29-3.94-17.35-7a22.33 22.33 0 01-2.81-5.5s.08 4.1 1.64 6.75 8 7.31 18.3 8.13z"
                                        style={{
                                            WebkitTransformOrigin: 212.92,
                                            MsTransformOrigin: 212.92,
                                            transformOrigin: 212.92,
                                        }}
                                        id="el9rgj8ltzre"
                                        fill="#F28F8F"
                                        className="animable"
                                    ></path>
                                    <path
                                        d="M219.29 48.69a1.94 1.94 0 11-1.92-2 2 2 0 011.92 2z"
                                        style={{
                                            WebkitTransformOrigin: 217.35,
                                            MsTransformOrigin: 217.35,
                                            transformOrigin: 217.35,
                                        }}
                                        id="elozidxx3mkmf"
                                        fill="#263238"
                                        className="animable"
                                    ></path>
                                    <path
                                        d="M217.91 40.6l-4.34 2.82a2.72 2.72 0 01.79-3.67 2.53 2.53 0 013.55.85z"
                                        style={{
                                            WebkitTransformOrigin: 215.54,
                                            MsTransformOrigin: 215.54,
                                            transformOrigin: 215.54,
                                        }}
                                        id="elxmtjytakw9i"
                                        fill="#263238"
                                        className="animable"
                                    ></path>
                                    <path
                                        d="M235.8 44.27L231 44a2.29 2.29 0 012.43-2.26 2.5 2.5 0 012.37 2.53z"
                                        style={{
                                            WebkitTransformOrigin: 233.4,
                                            MsTransformOrigin: 233.4,
                                            transformOrigin: 233.4,
                                        }}
                                        id="elq0bmwpdt2"
                                        fill="#263238"
                                        className="animable"
                                    ></path>
                                    <path
                                        d="M235.44 49.12a1.94 1.94 0 11-1.92-2 2 2 0 011.92 2z"
                                        style={{
                                            WebkitTransformOrigin: 233.5,
                                            MsTransformOrigin: 233.5,
                                            transformOrigin: 233.5,
                                        }}
                                        id="elwrtuhgwjzb"
                                        fill="#263238"
                                        className="animable"
                                    ></path>
                                    <path
                                        d="M226.21 59.54l7.11-2.85c-.93-1.4-6-10.71-9-11.49.02-.01 1.89 14.34 1.89 14.34z"
                                        style={{
                                            WebkitTransformOrigin: 228.82,
                                            MsTransformOrigin: 228.82,
                                            transformOrigin: 228.82,
                                        }}
                                        id="elz3f35nictm"
                                        fill="#F28F8F"
                                        className="animable"
                                    ></path>
                                    <path
                                        d="M218.88 60.52l6.34 2.55a3.35 3.35 0 01-4.39 2 3.59 3.59 0 01-1.95-4.55z"
                                        style={{
                                            WebkitTransformOrigin: 221.937,
                                            MsTransformOrigin: 221.937,
                                            transformOrigin: 221.937,
                                        }}
                                        id="eljincdnxau8g"
                                        fill="#B16668"
                                        className="animable"
                                    ></path>
                                    <path
                                        d="M218.68 61.51a3.53 3.53 0 002.15 3.58 3.29 3.29 0 002.29 0 5.26 5.26 0 00-4.44-3.58z"
                                        style={{
                                            WebkitTransformOrigin: 220.892,
                                            MsTransformOrigin: 220.892,
                                            transformOrigin: 220.892,
                                        }}
                                        id="elh78lzdaf14o"
                                        fill="#F28F8F"
                                        className="animable"
                                    ></path>
                                </g>
                                <g
                                    id="freepik--Mask--inject-2"
                                    style={{
                                        WebkitTransformOrigin: 220.039,
                                        MsTransformOrigin: 220.039,
                                        transformOrigin: 220.039,
                                    }}
                                    className="animable"
                                >
                                    <path
                                        d="M202.35 53.52c8.92 2.83 16.66 1.85 24.52-1.44a3.8 3.8 0 014.95 1.66s5.39 1.09 7.32-1.05c1.15 6.61-.83 18.75-6.69 22.39s-16.45 1.86-21.13-1.17a16.89 16.89 0 01-6.32-7.32l.19-10.59-1.64-.88z"
                                        style={{
                                            WebkitTransformOrigin: 220.901,
                                            MsTransformOrigin: 220.901,
                                            transformOrigin: 220.901,
                                        }}
                                        id="elg3k5trvuwhh"
                                        fill="#455A64"
                                        className="animable"
                                    ></path>
                                    <path
                                        d="M239.14 52.69c-1.93 2.14-8.27.55-8.27.55a2.44 2.44 0 00-.36-.32l-.31.64c1.39 6.5 0 17.61-2.89 23.3a13.88 13.88 0 005.14-1.78c5.86-3.64 7.84-15.78 6.69-22.39z"
                                        style={{
                                            WebkitTransformOrigin: 233.381,
                                            MsTransformOrigin: 233.381,
                                            transformOrigin: 233.381,
                                        }}
                                        id="elusscauyatg"
                                        fill="#37474F"
                                        className="animable"
                                    ></path>
                                    <path
                                        d="M222.4 55.45c4.35-1.36 6.33-2.54 8.49-.82 2 1.55 6.73 1.24 8.47-.1v-2c-3.08 1.94-7.16.69-7.16.69a4.5 4.5 0 00-5.39-1.38 34.41 34.41 0 01-24.42 1.72s-3.09-1.12-1.09.49a10.25 10.25 0 003.93 2 31.71 31.71 0 0017.17-.6z"
                                        style={{
                                            WebkitTransformOrigin: 219.993,
                                            MsTransformOrigin: 219.993,
                                            transformOrigin: 219.993,
                                        }}
                                        id="el95jkxlx9yw6"
                                        fill="#FAFAFA"
                                        className="animable"
                                    ></path>
                                    <path
                                        style={{
                                            WebkitTransformOrigin: 202.93,
                                            MsTransformOrigin: 202.93,
                                            transformOrigin: 202.93,
                                        }}
                                        id="el4f8gznxk41n"
                                        fill="#FAFAFA"
                                        d="M205.04 66.59L200.79 66.13 200.88 64.13 205.07 64.53 205.04 66.59z"
                                        className="animable"
                                    ></path>
                                </g>
                            </g>
                            <path
                                d="M196.87 109.06c0-1-.3-6.67-.39-9.4a153.34 153.34 0 01.89-22.3c.27-1.89.65-3.17 2.26-3l-.33 3.22a124.47 124.47 0 00-1.06 21.12c.09 2.79.47 9.25.51 10.35z"
                                style={{
                                    WebkitTransformOrigin: 198.013,
                                    MsTransformOrigin: 198.013,
                                    transformOrigin: 198.013,
                                }}
                                id="elgo3by4w1tvj"
                                fill="#BA68C8"
                                className="animable"
                            ></path>
                            <path
                                d="M193.19 153.17H193l.07-1.31a8.59 8.59 0 004.34-1.53 15.92 15.92 0 01-3.53-3.31c-2.07-2.77-6.36-22.4-4.85-26.92 1.26-3.8 5.16-12.15 8.5-12.24h.09c3.33.06 7.57 8.1 9 11.79 1.74 4.45-1.56 24.27-3.49 27.14a16.09 16.09 0 01-3.36 3.48 8.39 8.39 0 004.41 1.31l.14 1.3a10.17 10.17 0 01-5.71-1.76 10.55 10.55 0 01-5.42 2.05zm4.44-44c-2 0-5.59 6.24-7.28 11.33-1.39 4.16 2.73 23.15 4.65 25.72a15.35 15.35 0 003.65 3.3 15.39 15.39 0 003.47-3.47c1.79-2.67 4.95-21.84 3.36-25.93-1.98-4.96-5.87-10.91-7.85-10.94z"
                                style={{
                                    WebkitTransformOrigin: 197.913,
                                    MsTransformOrigin: 197.913,
                                    transformOrigin: 197.913,
                                }}
                                id="elah1uiy3av6s"
                                fill="#455A64"
                                className="animable"
                            ></path>
                            <path
                                d="M206.22 152.18a1.93 1.93 0 11-2-1.88 1.93 1.93 0 012 1.88z"
                                style={{
                                    WebkitTransformOrigin: 204.291,
                                    MsTransformOrigin: 204.291,
                                    transformOrigin: 204.291,
                                }}
                                id="elyo74nzb9nh"
                                fill="#263238"
                                className="animable"
                            ></path>
                            <path
                                d="M195 152.46a1.93 1.93 0 11-2-1.88 1.93 1.93 0 012 1.88z"
                                style={{
                                    WebkitTransformOrigin: 193.071,
                                    MsTransformOrigin: 193.071,
                                    transformOrigin: 193.071,
                                }}
                                id="elkw55698kivn"
                                fill="#263238"
                                className="animable"
                            ></path>
                            <path
                                d="M206.84 128.27l-1.1-.09a.43.43 0 01-.39-.47c.28-3.67.21-6.37-.22-7.46-1.86-4.77-5.77-10.79-7.53-10.74s-5.36 6.25-7 11.11c-.37 1.11-.31 3.81.16 7.45a.43.43 0 01-.37.49l-1.1.15a.43.43 0 01-.48-.38c-.54-4.09-.56-6.9-.08-8.34.86-2.6 4.9-12.36 8.8-12.45s8.42 9.44 9.42 12c.55 1.41.67 4.21.34 8.33a.44.44 0 01-.45.4z"
                                style={{
                                    WebkitTransformOrigin: 197.93,
                                    MsTransformOrigin: 197.93,
                                    transformOrigin: 197.93,
                                }}
                                id="el2c0t5jl7lqs"
                                fill="#BA68C8"
                                className="animable"
                            ></path>
                            <path
                                d="M222.89 77.09l-.21 2.25.14.07a15.75 15.75 0 012.31 1.59 16.13 16.13 0 012.55 2.69 30.87 30.87 0 013.32 6.54c2.72 6.45 3.71 17.39 3.88 30.08l2.13.32c0-4.52.25-19.53-4-30.87-2.78-7.52-7.01-11.17-10.12-12.67z"
                                style={{
                                    WebkitTransformOrigin: 229.846,
                                    MsTransformOrigin: 229.846,
                                    transformOrigin: 229.846,
                                }}
                                id="elqq8x5blopd"
                                fill="#BA68C8"
                                className="animable"
                            ></path>
                            <path
                                d="M229.93 118.3a6.3 6.3 0 106.88-5.67 6.32 6.32 0 00-6.88 5.67z"
                                style={{
                                    WebkitTransformOrigin: 236.201,
                                    MsTransformOrigin: 236.201,
                                    transformOrigin: 236.201,
                                }}
                                id="elhw9wvjev0bu"
                                fill="#455A64"
                                className="animable"
                            ></path>
                            <path
                                d="M232.64 118.56a3.58 3.58 0 103.91-3.22 3.58 3.58 0 00-3.91 3.22z"
                                style={{
                                    WebkitTransformOrigin: 236.204,
                                    MsTransformOrigin: 236.204,
                                    transformOrigin: 236.204,
                                }}
                                id="elqn4uxodmff"
                                fill="#37474F"
                                className="animable"
                            ></path>
                        </g>
                        <path
                            d="M238 228.56l4.72-7.46-18.27-11.52a2.19 2.19 0 00-2.24.11 6.91 6.91 0 00-3.33 5.28 2.22 2.22 0 00.79 2z"
                            style={{
                                WebkitTransformOrigin: 230.791,
                                MsTransformOrigin: 230.791,
                                transformOrigin: 230.791,
                            }}
                            id="elpqgyyb6zoh"
                            fill="#455A64"
                            className="animable"
                        ></path>
                        <path
                            d="M237.18 226.51c-.08 2 1.29 2.85 3 1.92a6.91 6.91 0 003.33-5.28c.07-2-1.29-2.85-3.05-1.92a6.89 6.89 0 00-3.28 5.28z"
                            style={{
                                WebkitTransformOrigin: 240.345,
                                MsTransformOrigin: 240.345,
                                transformOrigin: 240.345,
                            }}
                            id="elx91kt1ondfl"
                            fill="#37474F"
                            className="animable"
                        ></path>
                        <path
                            d="M240.6 223a1.12 1.12 0 01.94-.11l.24.16 12.74 8-4.25 2.24-10.6-6.69-.46-.28a1.23 1.23 0 01-.21-.8 3.36 3.36 0 011.6-2.52z"
                            style={{
                                WebkitTransformOrigin: 246.758,
                                MsTransformOrigin: 246.758,
                                transformOrigin: 246.758,
                            }}
                            id="elmfxdvu5wnjg"
                            fill="#E0E0E0"
                            className="animable"
                        ></path>
                        <path
                            d="M289.49 201.45l4.71-7.45-18.26-11.52a2.17 2.17 0 00-2.24.11 6.89 6.89 0 00-3.33 5.28 2.22 2.22 0 00.79 2z"
                            style={{
                                WebkitTransformOrigin: 282.276,
                                MsTransformOrigin: 282.276,
                                transformOrigin: 282.276,
                            }}
                            id="elfc3sojwyxvw"
                            fill="#455A64"
                            className="animable"
                        ></path>
                        <path
                            d="M268.37 178.41c9.59-.46 17.26.24 15.13 9.68-3.84-2.21-7.78 3-7.9 5.61s.61 4.09.11 5.72-3.19 3-4.29.57-3.27-5.75-3.47-9.78.92-9.21.42-11.8z"
                            style={{
                                WebkitTransformOrigin: 275.892,
                                MsTransformOrigin: 275.892,
                                transformOrigin: 275.892,
                            }}
                            id="eldhr2z3fq2ci"
                            fill="#FFA8A7"
                            className="animable"
                        ></path>
                        <path
                            d="M288.66 199.4c-.08 2 1.28 2.84 3 1.92A6.91 6.91 0 00295 196c.07-2-1.29-2.85-3.05-1.93a6.93 6.93 0 00-3.29 5.33z"
                            style={{
                                WebkitTransformOrigin: 291.83,
                                MsTransformOrigin: 291.83,
                                transformOrigin: 291.83,
                            }}
                            id="eloopm6wvzm2"
                            fill="#37474F"
                            className="animable"
                        ></path>
                        <path
                            d="M292.08 195.88a1.17 1.17 0 01.94-.12l.24.17L306 204l-4.25 2.24-10.6-6.69-.46-.28a1.23 1.23 0 01-.21-.8 3.34 3.34 0 011.6-2.59z"
                            style={{
                                WebkitTransformOrigin: 298.238,
                                MsTransformOrigin: 298.238,
                                transformOrigin: 298.238,
                            }}
                            id="el0p4eiog1idn"
                            fill="#E0E0E0"
                            className="animable"
                        ></path>
                        <path
                            d="M307.1 224.19L298 229l81.25 42.39a20.7 20.7 0 018.8 14.44l8.47 73.78a1.27 1.27 0 001.85 1c.43-.23.7-.69.62-2.47l-3.44-78.19c-.19-4.42-2.8-9.78-7.13-13.5z"
                            style={{
                                WebkitTransformOrigin: 348.502,
                                MsTransformOrigin: 348.502,
                                transformOrigin: 348.502,
                            }}
                            id="elml0y72do4m"
                            fill="#263238"
                            className="animable"
                        ></path>
                        <path
                            d="M308.08 359.29l-67.21-42.41a9.63 9.63 0 01-4.05-7.7l.16-4.05a9.62 9.62 0 014.64-7.36l70.31-37a9.62 9.62 0 018.69.34l67.2 42.38a9.6 9.6 0 014.05 7.7l-.16 4.1a9.58 9.58 0 01-4.64 7.36l-70.3 37a9.61 9.61 0 01-8.69-.36z"
                            style={{
                                WebkitTransformOrigin: 314.345,
                                MsTransformOrigin: 314.345,
                                transformOrigin: 314.345,
                            }}
                            id="elmlgq7g8q3jj"
                            fill="#BA68C8"
                            className="animable"
                        ></path>
                        <path
                            d="M309.33 359.89a6.88 6.88 0 01-1.25-.6l-67.21-42.41a9.66 9.66 0 01-4.05-7.7l.16-4.05a9.75 9.75 0 013.8-6.81c-1.6 1.32-1.4 3.18.64 4.47L308.31 345z"
                            style={{
                                WebkitTransformOrigin: 273.075,
                                MsTransformOrigin: 273.075,
                                transformOrigin: 273.075,
                            }}
                            id="eldhiicqx9egp"
                            className="animable"
                            opacity="0.3"
                        ></path>
                        <path
                            d="M391.88 311.18l-.17 4.1a9.56 9.56 0 01-4.64 7.36l-70.3 37a9.71 9.71 0 01-7.44.24l-1-14.91.32.2a9.55 9.55 0 008.69.34l70.31-37c2.14-1.12 2.48-3 1-4.41a9.78 9.78 0 013.23 7.08z"
                            style={{
                                WebkitTransformOrigin: 350.105,
                                MsTransformOrigin: 350.105,
                                transformOrigin: 350.105,
                            }}
                            id="elj6sns7u0ala"
                            className="animable"
                            opacity="0.15"
                        ></path>
                        <path
                            d="M335.84 275.83l-70.32 37a9.09 9.09 0 01-5.13.8 6.63 6.63 0 01-.76-.11h-.16l-.45-.1h-.06a5.67 5.67 0 01-.67-.2 7.51 7.51 0 01-1.46-.68l-3.46-2.18a12.29 12.29 0 01-4.93-7.65l-8.18-58.78a6.58 6.58 0 010-1.09v-.43a7.94 7.94 0 01.56-2.11 7.69 7.69 0 012.43-3.19l.3-.22a4.53 4.53 0 01.48-.27l70.3-37a9.61 9.61 0 018.69.34l3.46 2.18a9.46 9.46 0 012 1.78c.12.13.23.27.33.4A13.09 13.09 0 01330 206c.08.13.15.26.22.4s.13.24.19.36.17.35.24.52a4.93 4.93 0 01.22.53c.05.14.11.29.15.43a1.72 1.72 0 01.07.21c0 .13.07.26.11.39s.08.34.11.51a2.29 2.29 0 01.07.36l8.18 58.79a7.63 7.63 0 01-3.72 7.33z"
                            style={{
                                WebkitTransformOrigin: 289.917,
                                MsTransformOrigin: 289.917,
                                transformOrigin: 289.917,
                            }}
                            id="elphbrpq4mvk"
                            fill="#BA68C8"
                            className="animable"
                        ></path>
                        <path
                            d="M252.21 251.44l8.18 58.77c.38 2.75 2.68 3.93 5.13 2.64l70.31-37a7.65 7.65 0 003.75-7.32l-8.18-58.77c-.38-2.75-2.68-3.93-5.13-2.64l-70.31 37a7.69 7.69 0 00-3.75 7.32z"
                            style={{
                                WebkitTransformOrigin: 295.896,
                                MsTransformOrigin: 295.896,
                                transformOrigin: 295.896,
                            }}
                            id="elk8caima38rj"
                            fill="#BA68C8"
                            className="animable"
                        ></path>
                        <path
                            d="M252.21 251.44l8.18 58.77c.38 2.75 2.68 3.93 5.13 2.64l70.31-37a7.65 7.65 0 003.75-7.32l-8.18-58.77c-.38-2.75-2.68-3.93-5.13-2.64l-70.31 37a7.69 7.69 0 00-3.75 7.32z"
                            style={{
                                WebkitTransformOrigin: 295.896,
                                MsTransformOrigin: 295.896,
                                transformOrigin: 295.896,
                            }}
                            id="elgi7thlfdyj9"
                            className="animable"
                            opacity="0.15"
                        ></path>
                        <path
                            d="M263.72 313.48a10.27 10.27 0 01-3.33.17 6.63 6.63 0 01-.76-.11l-.61-.13h-.06a5.67 5.67 0 01-.67-.2 7.51 7.51 0 01-1.46-.68l-3.46-2.18a12.29 12.29 0 01-4.93-7.65l-8.18-58.78a6.58 6.58 0 010-1.09v-.43a7.94 7.94 0 01.56-2.11l12 7.45a7 7 0 00-.58 3.72l8.18 58.78c.28 2 1.63 3.22 3.32 3.15-.03.02-.02.05-.02.09z"
                            style={{
                                WebkitTransformOrigin: 251.989,
                                MsTransformOrigin: 251.989,
                                transformOrigin: 251.989,
                            }}
                            id="elhcy6c7wvfbl"
                            className="animable"
                            opacity="0.3"
                        ></path>
                    </g>
                    <g
                        id="freepik--bottom--inject-2"
                        style={{
                            WebkitTransformOrigin: 352.473,
                            MsTransformOrigin: 352.473,
                            transformOrigin: 352.473,
                        }}
                        className="animable"
                    >
                        <path
                            d="M390.62 339.31s7.44 33.44 10.75 43c2.14 6.15 8.85 13.13 14.27 18 1.18 1.06 3.76 3.05 4.78 3.84 2.25 1.75.71 3-1.27 3.56-4.65 1.24-9.34.34-14.85-2.8-6.34-3.63-9-6.69-14.6-11.11a22.5 22.5 0 01-4.7-4.8 6.59 6.59 0 01-.64-3.71 18.12 18.12 0 00-.24-4.15c-.9-4.61-16.67-30.61-16.67-30.61z"
                            style={{
                                WebkitTransformOrigin: 394.492,
                                MsTransformOrigin: 394.492,
                                transformOrigin: 394.492,
                            }}
                            id="eljwzgfcjbfhr"
                            fill="#FFBDA7"
                            className="animable"
                        ></path>
                        <path
                            d="M433.18 408.31c.31 0 .84 3.34-.86 4.79-2 1.68-7.75 4.46-15.46 3.6s-11.91-3.09-15-5.53-7.48-5.88-11-6.58c-3.25-.64-6.78-2-7.83-2.95s-1-5.23-1-5.23z"
                            style={{
                                WebkitTransformOrigin: 407.769,
                                MsTransformOrigin: 407.769,
                                transformOrigin: 407.769,
                            }}
                            id="elry0i6h2cojc"
                            fill="#263238"
                            className="animable"
                        ></path>
                        <path
                            d="M384.12 381.18c-1.24 0-1.48 1.26-1.32 2.26.9 5.54-1.43 10-.56 14.44.46 2.19 5.75 3.64 9.14 4.83a43.34 43.34 0 0111 6.49c3.65 2.82 11.3 5.6 16.32 5.61 7.66 0 12.59-2.06 14.08-4.73 1.85-3.3.47-6.56-8.55-10-4.19-1.59-8-3.2-9.84-4.61-8.56-6.54-10-9.49-11.9-12.6-1-1.63-1.32-2.31-3.53-2.25-2.93.09-5.66.95-7.23 2.83-.82 1.36-.67 3-.67 4.56 0 .21.1.59-.21.51-1.22-1.2-1.29-3.28-2.56-4.53-.74-1-3.86-1.65-3.86-1.65z"
                            style={{
                                WebkitTransformOrigin: 407.768,
                                MsTransformOrigin: 407.768,
                                transformOrigin: 407.768,
                            }}
                            id="el75wazgsaqag"
                            fill="#37474F"
                            className="animable"
                        ></path>
                        <path
                            d="M424.24 400.09c-11.08.88-16.63 7.76-17 11.85 6 2.57 9.22 2.86 11.51 2.87 7.66 0 12.9-2.06 14.4-4.73 1.7-3.08.07-7.64-8.91-9.99z"
                            style={{
                                WebkitTransformOrigin: 420.493,
                                MsTransformOrigin: 420.493,
                                transformOrigin: 420.493,
                            }}
                            id="elq9377d1rfqs"
                            fill="#FAFAFA"
                            className="animable"
                        ></path>
                        <path
                            d="M408.23 402.08a.54.54 0 01-.34-.12.51.51 0 01-.09-.73 13.29 13.29 0 0110-3.93.52.52 0 01.49.56.53.53 0 01-.59.47 12.3 12.3 0 00-9 3.55.58.58 0 01-.47.2z"
                            style={{
                                WebkitTransformOrigin: 412.989,
                                MsTransformOrigin: 412.989,
                                transformOrigin: 412.989,
                            }}
                            id="elkgmht7p70mq"
                            fill="#F0F0F0"
                            className="animable"
                        ></path>
                        <path
                            d="M403.33 398.48a.59.59 0 01-.35-.12.5.5 0 01-.08-.73 13.25 13.25 0 0110-3.93.52.52 0 11-.1 1 12.26 12.26 0 00-9 3.55.58.58 0 01-.47.23z"
                            style={{
                                WebkitTransformOrigin: 408.14,
                                MsTransformOrigin: 408.14,
                                transformOrigin: 408.14,
                            }}
                            id="el1coij7pgtec"
                            fill="#F0F0F0"
                            className="animable"
                        ></path>
                        <path
                            d="M398.84 394.91a.56.56 0 01-.35-.11.51.51 0 01-.08-.73 13.29 13.29 0 0110-3.94.53.53 0 01.48.57.53.53 0 01-.59.47 12.3 12.3 0 00-9 3.55.55.55 0 01-.46.19z"
                            style={{
                                WebkitTransformOrigin: 403.592,
                                MsTransformOrigin: 403.592,
                                transformOrigin: 403.592,
                            }}
                            id="el67frdv7ag1b"
                            fill="#F0F0F0"
                            className="animable"
                        ></path>
                        <path
                            d="M394.79 391.34a.53.53 0 01-.34-.11.51.51 0 01-.1-.73c2.09-2.61 6.86-4.37 10.89-4a.53.53 0 01.49.57.53.53 0 01-.59.47c-3.63-.33-8.08 1.28-9.93 3.6a.53.53 0 01-.42.2z"
                            style={{
                                WebkitTransformOrigin: 399.985,
                                MsTransformOrigin: 399.985,
                                transformOrigin: 399.985,
                            }}
                            id="el0cn3noedwee"
                            fill="#F0F0F0"
                            className="animable"
                        ></path>
                        <path
                            d="M357.19 358.48s7.44 33.44 10.75 43c2.14 6.15 8.85 13.13 14.27 18 1.18 1.06 3.76 3.05 4.78 3.84 2.24 1.75.7 3-1.28 3.57-4.64 1.23-9.34.33-14.84-2.81-6.34-3.62-9-6.69-14.61-11.11a22.74 22.74 0 01-4.7-4.71 6.65 6.65 0 01-.63-3.7 19.38 19.38 0 00-.24-4.16c-.9-4.6-16.68-30.61-16.68-30.61z"
                            style={{
                                WebkitTransformOrigin: 361.053,
                                MsTransformOrigin: 361.053,
                                transformOrigin: 361.053,
                            }}
                            id="elxihx6a0o8h"
                            fill="#FFBDA7"
                            className="animable"
                        ></path>
                        <path
                            d="M399.74 427.48c.32 0 .84 3.35-.85 4.79-2 1.68-7.75 4.46-15.46 3.6s-11.91-3.09-15-5.53-7.48-5.88-11-6.57c-3.24-.65-6.77-2-7.82-3s-1-5.23-1-5.23z"
                            style={{
                                WebkitTransformOrigin: 374.342,
                                MsTransformOrigin: 374.342,
                                transformOrigin: 374.342,
                            }}
                            id="el547oqtqehw"
                            fill="#263238"
                            className="animable"
                        ></path>
                        <path
                            d="M350.69 400.35c-1.25 0-1.49 1.26-1.33 2.26.9 5.54-1.42 10-.55 14.44.45 2.19 5.75 3.64 9.13 4.83a43.46 43.46 0 0111 6.49c3.66 2.82 11.31 5.6 16.32 5.61 7.66 0 12.59-2.06 14.09-4.73 1.85-3.3.46-6.56-8.56-10-4.18-1.59-8-3.2-9.83-4.61-8.57-6.54-10-9.48-11.9-12.59-1-1.64-1.32-2.32-3.53-2.25-2.93.09-5.66.94-7.23 2.82-.83 1.36-.67 3-.68 4.56 0 .21.1.59-.21.51-1.22-1.2-1.29-3.28-2.56-4.53-.74-1-3.86-1.65-3.86-1.65z"
                            style={{
                                WebkitTransformOrigin: 374.336,
                                MsTransformOrigin: 374.336,
                                transformOrigin: 374.336,
                            }}
                            id="el3p22pxwh2zi"
                            fill="#37474F"
                            className="animable"
                        ></path>
                        <path
                            d="M390.8 419.26c-11.07.88-16.62 7.77-17 11.85 6 2.57 9.21 2.87 11.5 2.87 7.66 0 12.91-2.06 14.4-4.73 1.72-3.11.08-7.64-8.9-9.99z"
                            style={{
                                WebkitTransformOrigin: 387.053,
                                MsTransformOrigin: 387.053,
                                transformOrigin: 387.053,
                            }}
                            id="eluepat2qs3zq"
                            fill="#FAFAFA"
                            className="animable"
                        ></path>
                        <path
                            d="M374.8 421.25a.66.66 0 01-.35-.11.52.52 0 01-.08-.74 13.27 13.27 0 0110-3.93.52.52 0 01.49.56.53.53 0 01-.59.47 12.3 12.3 0 00-9 3.55.55.55 0 01-.47.2z"
                            style={{
                                WebkitTransformOrigin: 379.556,
                                MsTransformOrigin: 379.556,
                                transformOrigin: 379.556,
                            }}
                            id="eluf438hr4ge"
                            fill="#F0F0F0"
                            className="animable"
                        ></path>
                        <path
                            d="M369.89 417.65a.6.6 0 01-.34-.11.53.53 0 01-.09-.74 13.25 13.25 0 0110-3.93.52.52 0 01.49.56.53.53 0 01-.59.47 12.32 12.32 0 00-9 3.55.53.53 0 01-.47.2z"
                            style={{
                                WebkitTransformOrigin: 374.65,
                                MsTransformOrigin: 374.65,
                                transformOrigin: 374.65,
                            }}
                            id="el93ecegrm32"
                            fill="#F0F0F0"
                            className="animable"
                        ></path>
                        <path
                            d="M365.4 414.09a.54.54 0 01-.34-.12.51.51 0 01-.09-.73 13.31 13.31 0 0110-3.94.53.53 0 01.49.57.53.53 0 01-.59.47 12.28 12.28 0 00-9 3.55.56.56 0 01-.47.2z"
                            style={{
                                WebkitTransformOrigin: 370.159,
                                MsTransformOrigin: 370.159,
                                transformOrigin: 370.159,
                            }}
                            id="el0vro1dq1raf"
                            fill="#F0F0F0"
                            className="animable"
                        ></path>
                        <path
                            d="M361.35 410.51a.52.52 0 01-.33-.11.51.51 0 01-.1-.73c2.09-2.61 6.86-4.37 10.89-4a.53.53 0 01.49.57.54.54 0 01-.59.47c-3.63-.33-8.08 1.29-9.93 3.6a.57.57 0 01-.43.2z"
                            style={{
                                WebkitTransformOrigin: 366.556,
                                MsTransformOrigin: 366.556,
                                transformOrigin: 366.556,
                            }}
                            id="elkkvdb4nhwth"
                            fill="#F0F0F0"
                            className="animable"
                        ></path>
                        <path
                            d="M389.71 321.27c-1.92-9.16-3.14-11.84-9.41-17.19-8-6.85-13.91-10.85-22.57-16.88-9.27-6.45-21.53-15.12-21.53-15.12l-65 14.36c0 6.83.21 14.8 3.85 22.26 4.61 9.47 12.55 15.34 20.38 19.8 16.1 9.17 31.68 20.24 31.68 20.24s1.49 6.18 3.64 13c2.77 8.8 4.68 11.39 9.68 21.18 5.92 11.57 8.41 15.6 8.41 15.6s12.22 2.64 17.15-6c0 0-8.7-44.21-10.16-51.72-3.16-16.32-6.78-18.24-9.89-21l16.09 11.4a107.49 107.49 0 006.26 19.39c4 9.38 13.37 27.9 13.37 27.9 4.6 1.33 15.92-3.24 18.3-5.78.04 0-6.73-34.62-10.25-51.44z"
                            style={{
                                WebkitTransformOrigin: 335.58,
                                MsTransformOrigin: 335.58,
                                transformOrigin: 335.58,
                            }}
                            id="elk61515hng5s"
                            fill="#455A64"
                            className="animable"
                        ></path>
                        <path
                            d="M362.07 331.2L346 319.8l-22.3-19.11c4.44-2.23 6.76-5.4 9.26-10.37C332.31 295.63 328 301 328 301z"
                            style={{
                                WebkitTransformOrigin: 342.885,
                                MsTransformOrigin: 342.885,
                                transformOrigin: 342.885,
                            }}
                            id="el7l5q08w38hq"
                            fill="#37474F"
                            className="animable"
                        ></path>
                    </g>
                    <g
                        id="freepik--top--inject-2"
                        style={{
                            WebkitTransformOrigin: 301.723,
                            MsTransformOrigin: 301.723,
                            transformOrigin: 301.723,
                        }}
                        className="animable"
                    >
                        <path
                            d="M288 159.86c-7.93 0-9.19 10.89-9.05 22.51s0 34.68 0 34.68h46.5v-39.77z"
                            style={{
                                WebkitTransformOrigin: 302.195,
                                MsTransformOrigin: 302.195,
                                transformOrigin: 302.195,
                            }}
                            id="elrmgjat2vohp"
                            fill="#263238"
                            className="animable"
                        ></path>
                        <path
                            d="M333.93 263.88c.2-.37-1.28-8.25-1.68-10.82-.68-4.29-1.21-6.57-1.21-6.57l-11.64-29.3-2.11-10.34s6.48-.44 9.8 1c4.29 1.82 5.76 4.47 9.13 11.38 2.9 5.91 10.33 25.19 11.09 28.43s.51 5.21-.48 10.23c-.76 3.88-1.49 7.69-2.59 11.92z"
                            style={{
                                WebkitTransformOrigin: 332.522,
                                MsTransformOrigin: 332.522,
                                transformOrigin: 332.522,
                            }}
                            id="elfs7awpny0ke"
                            fill="#FFBDA7"
                            className="animable"
                        ></path>
                        <path
                            d="M331.8 250.36c2.1-3.31 8.54-4.35 13-2.76-5.68-4.53-12.38-1-13.57-.39.1.64.31 1.69.57 3.15z"
                            style={{
                                WebkitTransformOrigin: 338.015,
                                MsTransformOrigin: 338.015,
                                transformOrigin: 338.015,
                            }}
                            id="ely1olo8paju"
                            fill="#F0997A"
                            className="animable"
                        ></path>
                        <g
                            id="freepik--Chest--inject-2"
                            style={{
                                WebkitTransformOrigin: 304.525,
                                MsTransformOrigin: 304.525,
                                transformOrigin: 304.525,
                            }}
                            className="animable"
                        >
                            <path
                                d="M272.44 237.26c0-11.51 4.25-19.39 6.56-25.84l12.62-2.63s10-1.36 16.09-1.65 9.58-.29 9.58-.29c4.08 4.33 16.56 15.58 19.8 24.09a16.78 16.78 0 01-4.36 18.68c-.21 5.95-.1 11.08-.1 11.08s3.22 6.32 3.57 11.38c-.53 15.23-25.9 32.45-65.42 18.53a109 109 0 013.08-27.4c.79-3.52-1.42-14.45-1.42-25.95z"
                                style={{
                                    WebkitTransformOrigin: 304.525,
                                    MsTransformOrigin: 304.525,
                                    transformOrigin: 304.525,
                                }}
                                id="el939pkl8afyi"
                                fill="#37474F"
                                className="animable"
                            ></path>
                            <path
                                d="M317.29 252s-5.06 6.13-15 4.93c-10.25-1.24-12.17-9.76-12.17-9.76s-.53 11.14 11.71 12.62a14.79 14.79 0 0015.46-7.79z"
                                style={{
                                    WebkitTransformOrigin: 303.703,
                                    MsTransformOrigin: 303.703,
                                    transformOrigin: 303.703,
                                }}
                                id="el0ohatw0iyc6n"
                                fill="#263238"
                                className="animable"
                            ></path>
                        </g>
                        <path
                            d="M288 159.86c-5.82 1.52-6.87 8.33-5.48 17.44s9.48 19.49 9.48 19.49l36-17.2a14.75 14.75 0 003.61-13.4c-1.77-8.35-8.22-14.29-18-15.68s-22.71.12-25.61 9.35z"
                            style={{
                                WebkitTransformOrigin: 306.979,
                                MsTransformOrigin: 306.979,
                                transformOrigin: 306.979,
                            }}
                            id="eltpuvbmyn25s"
                            fill="#263238"
                            className="animable"
                        ></path>
                        <path
                            d="M323.6 162.73a16.32 16.32 0 012.54 4.43c2.4 6.58 2.07 14.25 1.45 21.1-.77 8.5-3 12.4-6.8 14.41-1.84 1-5.25 1.86-10 1.06l-.12 5.65s11.06 8.33-1.86 9.25c-13.5 1-17.24-8.27-17.24-8.27l.56-20.7c-.76 1.23-5 3-7.93-.73-3.41-4.38-2.64-9.59.4-11.51s6.76-.09 8.15 3.47a3.9 3.9 0 004.55-1.44 8.93 8.93 0 001.52-2.71 18.62 18.62 0 00.34-2.24c.16-.72.13-1 .84-1.08.55-.07 1.11 0 1.66-.09a13.86 13.86 0 003.12-.65 9.36 9.36 0 004.38-3.05 1.15 1.15 0 01.49-.44 1.07 1.07 0 01.47 0 10.66 10.66 0 0012-8.18 22.25 22.25 0 011.48 1.72z"
                            style={{
                                WebkitTransformOrigin: 305,
                                MsTransformOrigin: 305,
                                transformOrigin: 305,
                            }}
                            id="el10xkfr21c0jf"
                            fill="#FFBDA7"
                            className="animable"
                        ></path>
                        <path
                            style={{
                                WebkitTransformOrigin: 318.78,
                                MsTransformOrigin: 318.78,
                                transformOrigin: 318.78,
                            }}
                            id="eluhahtcnp64"
                            fill="#F0997A"
                            d="M315.43 178.53L316 188.72 322.13 186.36 315.43 178.53z"
                            className="animable"
                        ></path>
                        <path
                            d="M310.48 183a3.54 3.54 0 01-.91.46 3.72 3.72 0 01-1.1.23 4.82 4.82 0 01-1.07-.13 2.76 2.76 0 01-.58-.16 1.89 1.89 0 01-.47-.3c-.08-.07-.09.1-.06.14a3.16 3.16 0 003.47.71 1.86 1.86 0 00.75-.91s0-.1-.03-.04z"
                            style={{
                                WebkitTransformOrigin: 308.392,
                                MsTransformOrigin: 308.392,
                                transformOrigin: 308.392,
                            }}
                            id="el1sphxd519ea"
                            fill="#F0997A"
                            className="animable"
                        ></path>
                        <path
                            d="M325.38 182.32a1.08 1.08 0 01-.24.12l-.24.14a3.42 3.42 0 01-.42.23 2.83 2.83 0 01-1 .25 4.41 4.41 0 01-1.2-.07 9.19 9.19 0 01-1-.36c-.06 0-.05.08 0 .11a2.84 2.84 0 002.43.79 3.32 3.32 0 001.12-.3 1.4 1.4 0 00.42-.3 1.32 1.32 0 00.2-.53s-.02-.13-.07-.08z"
                            style={{
                                WebkitTransformOrigin: 323.344,
                                MsTransformOrigin: 323.344,
                                transformOrigin: 323.344,
                            }}
                            id="el2wyozyq9wey"
                            fill="#F0997A"
                            className="animable"
                        ></path>
                        <path
                            d="M311.7 172.7a1.41 1.41 0 00-.79-.49 1.63 1.63 0 00-.49 0l-.24.05c-.08 0-.12 0-.14.12a.14.14 0 00.06.16.24.24 0 00.17 0h.25a2.7 2.7 0 01.39.08l.14.07h.07a.12.12 0 01.05.05.37.37 0 01.07.12v.12a.28.28 0 010 .09.22.22 0 010 .08 1.36 1.36 0 010 .17c0 .12 0 .18-.09.3V174.03c0 .08.09.24.2.2a1.53 1.53 0 00.21-.14.73.73 0 00.16-.14l.09-.12a1.33 1.33 0 00.09-.21 1.17 1.17 0 00.05-.2 1.28 1.28 0 00-.25-.72z"
                            style={{
                                WebkitTransformOrigin: 310.992,
                                MsTransformOrigin: 310.992,
                                transformOrigin: 310.992,
                            }}
                            id="elmkwoqa8ig"
                            fill="#F0997A"
                            className="animable"
                        ></path>
                        <path
                            d="M315.1 194.78c-1 .63-1.48-.57-3.17-1.28s-2.95 0-3-1.23c-.06-1 1.53-2.79 4.4-1.81 2.43.84 2.67 3.75 1.77 4.32z"
                            style={{
                                WebkitTransformOrigin: 312.255,
                                MsTransformOrigin: 312.255,
                                transformOrigin: 312.255,
                            }}
                            id="elokmnoc5031e"
                            fill="#B16668"
                            className="animable"
                        ></path>
                        <path
                            d="M310.31 190.46a2.15 2.15 0 00-1.39 1.81c.06 1.22 1.35.54 3 1.23a8.36 8.36 0 011.72 1.06 4.88 4.88 0 00-3.33-4.1z"
                            style={{
                                WebkitTransformOrigin: 311.28,
                                MsTransformOrigin: 311.28,
                                transformOrigin: 311.28,
                            }}
                            id="elolsfiywd16f"
                            fill="#F0997A"
                            className="animable"
                        ></path>
                        <path
                            d="M310.8 203.73c-10.14-2.2-15.82-6.32-16.86-10.43 0 0 .64 5.37 3.48 7.74 4 3.32 13.32 5.49 13.32 5.49z"
                            style={{
                                WebkitTransformOrigin: 302.37,
                                MsTransformOrigin: 302.37,
                                transformOrigin: 302.37,
                            }}
                            id="ely44mne9srbg"
                            fill="#F0997A"
                            className="animable"
                        ></path>
                        <path
                            d="M311.12 179.81c-.29-1-1 .82-2.32 1.19s-2.61-.88-2.31.14a2.47 2.47 0 004.63-1.33z"
                            style={{
                                WebkitTransformOrigin: 308.785,
                                MsTransformOrigin: 308.785,
                                transformOrigin: 308.785,
                            }}
                            id="elf5llrc3hyss"
                            fill="#263238"
                            className="animable"
                        ></path>
                        <path
                            d="M325.13 180.49c.16-1.05-1.18.33-2.37.14s-1.8-1.86-2-.8a2.21 2.21 0 004.33.66z"
                            style={{
                                WebkitTransformOrigin: 322.951,
                                MsTransformOrigin: 322.951,
                                transformOrigin: 322.951,
                            }}
                            id="el9q7kxfjx4gd"
                            fill="#263238"
                            className="animable"
                        ></path>
                        <path
                            d="M320.92 172.31l3.69 2.93a2.26 2.26 0 01-3.26.43 2.45 2.45 0 01-.43-3.36z"
                            style={{
                                WebkitTransformOrigin: 322.525,
                                MsTransformOrigin: 322.525,
                                transformOrigin: 322.525,
                            }}
                            id="eloex6as3tds"
                            fill="#263238"
                            className="animable"
                        ></path>
                        <path
                            d="M308.89 173.35l-4.28 2.12a2.31 2.31 0 003.14 1.12 2.48 2.48 0 001.14-3.24z"
                            style={{
                                WebkitTransformOrigin: 306.861,
                                MsTransformOrigin: 306.861,
                                transformOrigin: 306.861,
                            }}
                            id="elcts5ze34sd8"
                            fill="#263238"
                            className="animable"
                        ></path>
                        <path
                            d="M300.86 270.69c4.53 1.48 8 2.21 10 .63a28.82 28.82 0 015-3.12 15.39 15.39 0 014.87-1.53 18.66 18.66 0 013.92-.57c.42.11 2.24 1 4.69 1.89 1.18.41 1.35 2.94-1.11 3.63a12.62 12.62 0 01-4.83.29s1.31 2.25 2.65 2.35 4.45-.67 7.58-1.64 4.65-1.32 5.62.21c.27.38-2.74 3.11-2.74 3.11a9.06 9.06 0 01-.31 4.59c-.82 2.66-6.22 7.41-9.86 9.13a20.53 20.53 0 01-8.66 2c-2.51.13-6.69-1.53-9.89-2.71a75.31 75.31 0 00-10.3-2.6z"
                            style={{
                                WebkitTransformOrigin: 318.379,
                                MsTransformOrigin: 318.379,
                                transformOrigin: 318.379,
                            }}
                            id="ely106ixmnb7q"
                            fill="#FFBDA7"
                            className="animable"
                        ></path>
                        <path
                            d="M336.6 277.51a3.88 3.88 0 00-1.8-2.42l-4.67-.16a11.93 11.93 0 01-5.28 3.46 34.68 34.68 0 00-5.85 2.51 3.79 3.79 0 00-1.18 1 3.72 3.72 0 00-.52 2.07 1.85 1.85 0 00.19 1 1.93 1.93 0 001.59.68 16.6 16.6 0 004.5-.31c-1.24 1.77-4 2.14-4.89 4.12a4.16 4.16 0 00-.22 2.16 19.76 19.76 0 007.9-2c3.64-1.72 9-6.47 9.86-9.13a10.28 10.28 0 00.46-2.72c-.04-.06-.06-.16-.09-.26z"
                            style={{
                                WebkitTransformOrigin: 326.991,
                                MsTransformOrigin: 326.991,
                                transformOrigin: 326.991,
                            }}
                            id="eljuvdvhe2wd"
                            fill="#F0997A"
                            className="animable"
                        ></path>
                        <path
                            d="M344.77 262.29l-12.16-7.2a53.91 53.91 0 01-.36 6.88 3.65 3.65 0 01-2.2 2.93 6.12 6.12 0 00-1.91 1.13 39.58 39.58 0 01-4.06 3.25c-1.3.93-2.48 1.92-1.18 3.06a3.22 3.22 0 003.34.78 14.75 14.75 0 002.8-1.06 9.52 9.52 0 001.26 2.16l-1.08 1.35a19 19 0 01-2.64 2.25 33.66 33.66 0 01-4.15 2.25c-1.45.69-4 1.59-3.93 3.35s.82 1.39 2.44 1.18 7.14-1.88 7.14-1.88a17.76 17.76 0 01-2 2.09c-.77.61-2.69 2.41-4.34 3.69s-2.76 3.07-2.07 4.46 2.15.06 3.53-.69 2.53-1.29 2.53-1.29-1.33 1.32-2 1.94a2.54 2.54 0 00-.77 2.71c.46.91.92 1.18 2 .52s2.18-1.64 3.32-2.3a10.54 10.54 0 001.67-1.16s-1.47 1.71-1.22 2.6.93 1.4 1.6 1.09 2.23-1.9 3.43-2.51a17.63 17.63 0 002.85-2c.77-.57.91-1.14 1.34-2.69s.91-3 1.46-4.59c.64-1.93 1.3-3.75 2-5.85.78-2.4 1.64-3.81 2.41-7.2.91-3.76.81-4.73.95-9.25z"
                            style={{
                                WebkitTransformOrigin: 331.634,
                                MsTransformOrigin: 331.634,
                                transformOrigin: 331.634,
                            }}
                            id="el3ne9eekqrp"
                            fill="#FFBDA7"
                            className="animable"
                        ></path>
                        <path
                            d="M332.49 259.89a13.94 13.94 0 01-.24 2.08 4.62 4.62 0 01-1 2.1 6.72 6.72 0 015.28-1.37c-.45-.54-2.1-.53-2.9-.53s-1.2-1.08-1.14-2.28z"
                            style={{
                                WebkitTransformOrigin: 333.89,
                                MsTransformOrigin: 333.89,
                                transformOrigin: 333.89,
                            }}
                            id="el66fn0t57i58"
                            fill="#F0997A"
                            className="animable"
                        ></path>
                        <path
                            d="M331.2 267a3.13 3.13 0 00-1-.85 3 3 0 00-.64-.26l-.32-.07h-.29a.19.19 0 000 .25.66.66 0 00.3.07l.27.06a3.1 3.1 0 01.6.23 2.81 2.81 0 01.9.71c.17.13.25-.07.18-.14z"
                            style={{
                                WebkitTransformOrigin: 330.064,
                                MsTransformOrigin: 330.064,
                                transformOrigin: 330.064,
                            }}
                            id="el8jr6pawb0cl"
                            fill="#F0997A"
                            className="animable"
                        ></path>
                        <path
                            d="M330.06 267.44a2.76 2.76 0 00-.71-.45 1.63 1.63 0 00-.37-.13c-.1 0-.31-.1-.36 0a.15.15 0 000 .16.77.77 0 00.39.14 1.93 1.93 0 01.34.11 2 2 0 01.61.33c.14.12.18-.09.1-.16z"
                            style={{
                                WebkitTransformOrigin: 329.349,
                                MsTransformOrigin: 329.349,
                                transformOrigin: 329.349,
                            }}
                            id="elm7a71cpydho"
                            fill="#F0997A"
                            className="animable"
                        ></path>
                        <path
                            d="M328.12 280.11c-.09-.06-.11.13-.06.17a2.55 2.55 0 01.49 2.11.23.23 0 00.11.23.11.11 0 00.17-.08 2.68 2.68 0 00-.71-2.43z"
                            style={{
                                WebkitTransformOrigin: 328.46,
                                MsTransformOrigin: 328.46,
                                transformOrigin: 328.46,
                            }}
                            id="elmo3ctvmt9rd"
                            fill="#F0997A"
                            className="animable"
                        ></path>
                        <path
                            d="M328.24 282.38a2.28 2.28 0 000-.45 1.39 1.39 0 00-.42-.81.11.11 0 00-.16 0 .17.17 0 000 .19c0 .08.06.12.09.19v.13a1.64 1.64 0 01.05.32v.54a.54.54 0 00.16.34.13.13 0 00.13 0c.17-.05.15-.29.15-.45z"
                            style={{
                                WebkitTransformOrigin: 327.941,
                                MsTransformOrigin: 327.941,
                                transformOrigin: 327.941,
                            }}
                            id="elhw83x1nwhm8"
                            fill="#F0997A"
                            className="animable"
                        ></path>
                        <path
                            d="M326.67 289.13a1.9 1.9 0 00-.73-.83s-.05.07 0 .09a5.22 5.22 0 01.52.85 2.56 2.56 0 01.2.95.28.28 0 00.18.21.13.13 0 00.17-.12 2.89 2.89 0 00-.34-1.15z"
                            style={{
                                WebkitTransformOrigin: 326.464,
                                MsTransformOrigin: 326.464,
                                transformOrigin: 326.464,
                            }}
                            id="el9ifbdyoufaa"
                            fill="#F0997A"
                            className="animable"
                        ></path>
                        <path
                            d="M326.39 290.25a.58.58 0 00-.05-.14 1.89 1.89 0 00-.11-.25 2.51 2.51 0 00-.27-.37s-.11-.07-.15 0a.19.19 0 000 .2l.11.16.05.09a1.46 1.46 0 01.07.19.29.29 0 000 .09.24.24 0 00.09.11h.11a.1.1 0 000-.07.29.29 0 00.15-.01z"
                            style={{
                                WebkitTransformOrigin: 326.086,
                                MsTransformOrigin: 326.086,
                                transformOrigin: 326.086,
                            }}
                            id="elkagxq9ds4ii"
                            fill="#F0997A"
                            className="animable"
                        ></path>
                        <path
                            d="M330.63 285.84a2.69 2.69 0 00-.83-1 .08.08 0 00-.14 0 .2.2 0 000 .2 5.64 5.64 0 01.67.93 5.34 5.34 0 01.38 1.08c0 .12.21.17.21 0a2.71 2.71 0 00-.29-1.21z"
                            style={{
                                WebkitTransformOrigin: 330.277,
                                MsTransformOrigin: 330.277,
                                transformOrigin: 330.277,
                            }}
                            id="elj6b4e4ux0hl"
                            fill="#F0997A"
                            className="animable"
                        ></path>
                        <path
                            d="M330.31 287a1.9 1.9 0 00-.35-.49s-.12-.07-.16 0a.2.2 0 000 .21 1.14 1.14 0 01.23.38 1.55 1.55 0 01.07.23v.2a.5.5 0 000 .13c0 .06.09.16.17.12h.05a.08.08 0 000-.05.09.09 0 000-.05.76.76 0 000-.15 1.77 1.77 0 00-.01-.53z"
                            style={{
                                WebkitTransformOrigin: 330.053,
                                MsTransformOrigin: 330.053,
                                transformOrigin: 330.053,
                            }}
                            id="eltrv0gsydzao"
                            fill="#F0997A"
                            className="animable"
                        ></path>
                        <path
                            d="M330.06 292.46a1.57 1.57 0 00-.06-.28 1.88 1.88 0 00-.26-.58 1.54 1.54 0 00-.8-.69c-.1 0-.07.15 0 .19a2.25 2.25 0 01.64.7 2 2 0 01.16.43v.19a.49.49 0 010 .12.58.58 0 00.1.21s.07.06.11 0 .11-.1.11-.19v-.1z"
                            style={{
                                WebkitTransformOrigin: 329.468,
                                MsTransformOrigin: 329.468,
                                transformOrigin: 329.468,
                            }}
                            id="elix4eki7cn7"
                            fill="#F0997A"
                            className="animable"
                        ></path>
                        <path
                            d="M336.57 291.87v-.24a2.83 2.83 0 00-.13-.5 2.1 2.1 0 00-.24-.41.77.77 0 00-.37-.32c-.15 0-.13.18-.07.25s.18.19.23.27a1 1 0 01.14.28 3.45 3.45 0 01.12.43 3.25 3.25 0 00.1.47c.05.12.22.18.26 0a.76.76 0 00-.04-.23z"
                            style={{
                                WebkitTransformOrigin: 336.163,
                                MsTransformOrigin: 336.163,
                                transformOrigin: 336.163,
                            }}
                            id="el596xff5073j"
                            fill="#F0997A"
                            className="animable"
                        ></path>
                        <path
                            d="M329.06 272.06a9.52 9.52 0 001.26 2.16l2.23-2.44-1.55 1.36v-1.48s2.44-2 3-3.58a15.91 15.91 0 01-4.94 3.98z"
                            style={{
                                WebkitTransformOrigin: 331.53,
                                MsTransformOrigin: 331.53,
                                transformOrigin: 331.53,
                            }}
                            id="elw9jqnuxuwlm"
                            fill="#F0997A"
                            className="animable"
                        ></path>
                        <path
                            d="M328.1 282.72a23.91 23.91 0 002.21-1.37 6.59 6.59 0 011.18-.61 11.6 11.6 0 011.25-.44 12.19 12.19 0 01-1.11.71 11.19 11.19 0 00-1.11.66 6 6 0 01-2.42 1.05z"
                            style={{
                                WebkitTransformOrigin: 330.42,
                                MsTransformOrigin: 330.42,
                                transformOrigin: 330.42,
                            }}
                            id="el5atdcuxfjea"
                            fill="#F0997A"
                            className="animable"
                        ></path>
                        <path
                            d="M325.79 291c.79-.5 1.53-1.06 2.27-1.63s1.47-1.14 2.19-1.72 1.27-1.34 2-2a8.42 8.42 0 012.42-1.45 11.45 11.45 0 00-2.21 1.67c-.66.65-1.21 1.39-1.95 2s-1.48 1.14-2.26 1.67a14.35 14.35 0 01-2.46 1.46z"
                            style={{
                                WebkitTransformOrigin: 330.23,
                                MsTransformOrigin: 330.23,
                                transformOrigin: 330.23,
                            }}
                            id="el7zoxsjmg083"
                            fill="#F0997A"
                            className="animable"
                        ></path>
                        <path
                            d="M329.93 292.79a7.59 7.59 0 00.84-.77c.27-.26.55-.52.84-.77.59-.5 1.19-.95 1.73-1.47a13.07 13.07 0 001.52-1.64l.65-.93a3.16 3.16 0 01.8-.83 3.5 3.5 0 00-.64.93c-.18.33-.36.67-.56 1a9.76 9.76 0 01-1.51 1.76 18.59 18.59 0 01-1.8 1.41 15.28 15.28 0 01-1.87 1.31z"
                            style={{
                                WebkitTransformOrigin: 333.12,
                                MsTransformOrigin: 333.12,
                                transformOrigin: 333.12,
                            }}
                            id="ele52n19xr4j"
                            fill="#F0997A"
                            className="animable"
                        ></path>
                        <path
                            d="M334.77 288.52l-.13 1.1-1.25.38a14.24 14.24 0 001.38-1.48z"
                            style={{
                                WebkitTransformOrigin: 334.08,
                                MsTransformOrigin: 334.08,
                                transformOrigin: 334.08,
                            }}
                            id="el3rl3tpwobnm"
                            fill="#F0997A"
                            className="animable"
                        ></path>
                        <path
                            d="M328.16 266a32 32 0 01-3 2.54c-.52.4-1.06.78-1.58 1.18a2.62 2.62 0 00-1.12 1.5 1.09 1.09 0 00.33.82 4.44 4.44 0 00.75.61 2.68 2.68 0 001.8.47 11.07 11.07 0 003.68-1.21l.13-.06.06.13a9 9 0 001.24 2.12l.08.09-.07.09-1.08 1.36a19.4 19.4 0 01-2.31 2 23.11 23.11 0 01-2.64 1.59c-.91.47-1.83.92-2.76 1.34a7.29 7.29 0 00-2.48 1.61 1.75 1.75 0 00-.44 1.27c0 .48.11 1 .51 1a6.21 6.21 0 001.44-.13 12.61 12.61 0 001.49-.28c2-.48 3.92-1.06 5.87-1.65l.75-.23-.5.6a19.22 19.22 0 01-1.78 1.95c-.68.56-1.3 1.13-2 1.71s-1.31 1.14-2 1.69a10.29 10.29 0 00-1.88 1.71 3.5 3.5 0 00-.91 2.2 1.58 1.58 0 00.39 1c.22.25.6.22 1 .06.75-.3 1.46-.85 2.24-1.25s1.55-.8 2.34-1.17l1.1-.52-.87.85-1.29 1.25-.65.76a3.34 3.34 0 00-.53.66 2.27 2.27 0 00-.38 1.56c.13.47.48 1.12.94 1.11a3.13 3.13 0 001.5-.71c.48-.33 1-.69 1.44-1 1-.74 2.08-1.24 2.95-2l.22.21a9.44 9.44 0 00-.75 1 3.12 3.12 0 00-.46 1.15.78.78 0 000 .27 2.49 2.49 0 00.11.29 1.56 1.56 0 00.33.5.83.83 0 001 .18c.71-.44 1.36-1.07 2.06-1.59a10.56 10.56 0 011.1-.74 12.28 12.28 0 001.13-.64c.73-.47 1.39-1.05 2.09-1.56a4.32 4.32 0 001.12-2.28c.47-1.69 1.18-3.29 1.62-5-.41 1.7-1.1 3.32-1.53 5-.12.42-.23.85-.38 1.26a2.53 2.53 0 01-.74 1.11c-.69.53-1.34 1.12-2.07 1.61a12.09 12.09 0 01-1.13.68 8.41 8.41 0 00-1.06.74 24.47 24.47 0 01-2.08 1.62 1.06 1.06 0 01-.72.14 1.19 1.19 0 01-.64-.35 1.85 1.85 0 01-.39-.58 2.19 2.19 0 01-.12-.33 1.17 1.17 0 010-.37 3.41 3.41 0 01.49-1.28 10.31 10.31 0 01.78-1.09l.22.22c-.93.82-2 1.3-3 2-.48.35-.95.72-1.45 1.06-.25.18-.49.34-.76.5a1.9 1.9 0 01-.94.29 1.09 1.09 0 01-.87-.52 2.35 2.35 0 01-.42-.87 2.61 2.61 0 01.41-1.84 4.26 4.26 0 01.59-.74l.64-.62 1.27-1.26.23.33c-.78.37-1.55.77-2.31 1.18s-1.43.92-2.28 1.29a2.05 2.05 0 01-.72.15 1.09 1.09 0 01-.74-.3 2 2 0 01-.53-1.34 4 4 0 011-2.52 11 11 0 011.94-1.8c.67-.54 1.31-1.11 2-1.68s1.31-1.16 2-1.7a19.34 19.34 0 001.74-1.87l.25.37c-2 .58-3.92 1.14-5.91 1.62-.5.11-1 .22-1.53.28a5.75 5.75 0 01-1.58.11.91.91 0 01-.7-.61 2.63 2.63 0 01-.13-.81 2.11 2.11 0 01.55-1.54 7.42 7.42 0 012.62-1.69c.93-.42 1.84-.86 2.75-1.32a22.06 22.06 0 002.61-1.54 19.49 19.49 0 002.28-2l1.09-1.35v.18a8.94 8.94 0 01-1.27-2.2l.19.08a10.75 10.75 0 01-3.79 1.19 2.89 2.89 0 01-1.93-.54 4 4 0 01-.77-.65 1.26 1.26 0 01-.36-1 1.67 1.67 0 01.47-.9 5.21 5.21 0 01.74-.67c.53-.4 1.07-.76 1.6-1.15a33.27 33.27 0 003.06-2.39z"
                            style={{
                                WebkitTransformOrigin: 328.903,
                                MsTransformOrigin: 328.903,
                                transformOrigin: 328.903,
                            }}
                            id="el0nrbcta1v13"
                            fill="#B16668"
                            className="animable"
                        ></path>
                        <path
                            d="M283.07 210.57c-8.55 1.51-14.52 4.13-18 14.46s-7.88 33.63-8.86 39c-1.7 9.34.73 10.85 7.95 14.11 4.84 2.19 21.06 6.28 33.31 8.19l3.36-15.69c-12.2-4.61-22.57-9-22.57-9l5.16-22.65s6.19-18.2-.35-28.42z"
                            style={{
                                WebkitTransformOrigin: 278.26,
                                MsTransformOrigin: 278.26,
                                transformOrigin: 278.26,
                            }}
                            id="elpyrl0dydr7"
                            fill="#FFBDA7"
                            className="animable"
                        ></path>
                        <path
                            d="M278.29 261.72c-5.55-2-12.37-.05-14.78 1.95 3-5.25 11.52-6.32 15.46-4.95z"
                            style={{
                                WebkitTransformOrigin: 271.24,
                                MsTransformOrigin: 271.24,
                                transformOrigin: 271.24,
                            }}
                            id="el4bxgn0nt87j"
                            fill="#F0997A"
                            className="animable"
                        ></path>
                    </g>
                    <g
                        id="freepik--Arm--inject-2"
                        style={{
                            WebkitTransformOrigin: 195.585,
                            MsTransformOrigin: 195.585,
                            transformOrigin: 195.585,
                        }}
                        className="animable"
                    >
                        <path
                            d="M161.39 129.07c.89 13.85 1.34 18.57 2.19 26.84.7 6.74 2.31 9.54 9.16 19.18 4.9 6.89 13.68 15.57 18.6 21.78 5.23-1 11.75-7.39 15.12-10.79-7.18-11.2-16.7-32.47-16.7-32.47l-.9-33.43s-1.11-23.59-13.47-33.48c-10.76 4-12.76 9.7-14 15.84s-.97 11.46 0 26.53z"
                            style={{
                                WebkitTransformOrigin: 183.509,
                                MsTransformOrigin: 183.509,
                                transformOrigin: 183.509,
                            }}
                            id="elylqd3zn3vfb"
                            fill="#E6E6E6"
                            className="animable"
                        ></path>
                        <path
                            d="M191.74 196.69c5.43-2.18 10.93-7 14.23-10.28a55.79 55.79 0 008.39 9.64c2.75 2.72 9.22 5.86 13.35 9.64s2.64 7.56 2.64 7.56l-5.13-3.25c-2.69-1.49-7.48 4.91-4.84 7.5l5.37 3.38c-3.52 2.44-9.76 3.44-12 1.82s-3.66-1.42-8.14-4.36-5.9-8.33-9.78-13.8c-1.26-1.81-1.75-4.9-4.09-7.85z"
                            style={{
                                WebkitTransformOrigin: 211.176,
                                MsTransformOrigin: 211.176,
                                transformOrigin: 211.176,
                            }}
                            id="eleko3qp8roj4"
                            fill="#FFA8A7"
                            className="animable"
                        ></path>
                    </g>
                    <g
                        id="freepik--Wheel--inject-2"
                        style={{
                            WebkitTransformOrigin: 258.97,
                            MsTransformOrigin: 258.97,
                            transformOrigin: 258.97,
                        }}
                        className="animable"
                    >
                        <path
                            d="M243.94 267.61l.77 5.56 58.87 38.08a20.71 20.71 0 017.19 14.8l4.43 77.43a1.26 1.26 0 01-2 1.08l-23.49-14.94.2-5.06L309.42 397l-6.21-66.35a20.7 20.7 0 00-8.8-14.44l-52.24-36c-5.93-3.81-3.43-9.57 1.77-12.6z"
                            style={{
                                WebkitTransformOrigin: 276.967,
                                MsTransformOrigin: 276.967,
                                transformOrigin: 276.967,
                            }}
                            id="elr0vmin8jr2l"
                            fill="#37474F"
                            className="animable"
                        ></path>
                        <path
                            d="M255.66 303.77l-2.58-1.63c-6.34-4-12.4-6-17.86-6.33h-.47a24.12 24.12 0 00-2.83.06 31 31 0 00-21.63 11l-.31.35a7.93 7.93 0 00-.53.65l-.35.44c-.15.19-.28.38-.41.56-.25.37-.51.73-.74 1.11l-.26.41c-.11.18-.21.37-.33.56v.07a31 31 0 00-4.36 14.59v1.24c0 .56-.08 1.14-.1 1.72l-.12 3.05c-1 26.37 16.22 59.16 38.55 73.23l2.57 1.63c6.35 4 12.41 6 17.87 6.33h3.41a31 31 0 0022.13-11.7c.23-.28.45-.57.67-.86a.76.76 0 01.08-.11c.25-.34.49-.69.73-1a30.88 30.88 0 005.2-16l.12-3 .12-3c1.01-26.51-16.23-59.3-38.57-73.37zM243 396.7c-18.85-11.88-33.42-39.56-32.55-61.82s16.85-30.68 35.69-18.79 33.42 39.56 32.55 61.82-16.9 30.68-35.69 18.79z"
                            style={{
                                WebkitTransformOrigin: 248.505,
                                MsTransformOrigin: 248.505,
                                transformOrigin: 248.505,
                            }}
                            id="el8u5wycdz7mr"
                            fill="#455A64"
                            className="animable"
                        ></path>
                        <path
                            d="M247.73 308l-2.57-1.63c-11-7-21.25-8-28.88-4.16a5.7 5.7 0 00-.59.32l-.15.08c-.23.13-.46.26-.68.4s-.45.28-.67.44a12.44 12.44 0 00-1.29.94c-.21.16-.41.34-.61.51a15.62 15.62 0 00-1.19 1.1c-.2.19-.39.4-.57.6s-.37.41-.55.62a7.93 7.93 0 00-.53.65l-.35.44c-.15.19-.28.38-.41.56-.25.37-.51.73-.74 1.11l-.26.41c-.11.18-.21.37-.33.56l-.3.56c-.37.69-.73 1.4-1 2.14-.18.4-.35.79-.5 1.2v.05c-.29.73-.55 1.5-.79 2.28-.13.43-.25.85-.37 1.3s-.26 1-.38 1.51l-.15.73c-.09.42-.17.85-.24 1.27s-.16.95-.23 1.45v.24c-.05.41-.11.83-.15 1.26 0 .17 0 .34-.05.52 0 .46-.1.94-.12 1.43s-.08 1.14-.1 1.72l-.12 3.05c-1 26.37 16.22 59.16 38.55 73.23l2.57 1.63c6.49 4.08 12.68 6.14 18.24 6.36h2.8l.91-.09.81-.11c.27 0 .52-.08.78-.14.5-.09 1-.21 1.46-.34l.61-.17c.23-.07.46-.13.67-.21s.38-.13.56-.21a10.41 10.41 0 001.2-.49c.19-.08.39-.17.58-.27l.16-.08a1.19 1.19 0 00.22-.12c.13-.05.25-.12.37-.18 7.52-4.1 12.4-13.12 12.91-26.16l.12-3.05c.93-26.46-16.33-59.26-38.65-73.26zM243 396.7c-18.85-11.88-33.42-39.56-32.55-61.82s16.85-30.68 35.69-18.79 33.42 39.56 32.55 61.82-16.9 30.68-35.69 18.79z"
                            style={{
                                WebkitTransformOrigin: 244.617,
                                MsTransformOrigin: 244.617,
                                transformOrigin: 244.617,
                            }}
                            id="eltnwlc21g3th"
                            fill="#37474F"
                            className="animable"
                        ></path>
                        <path
                            d="M269.13 392c-5.77 6.35-15.38 6.91-26 .22-16.75-10.56-29.71-35.17-28.93-55 .34-8.84 3.37-15.23 8.12-18.65-3.36 3.67-5.44 9.26-5.72 16.5-.78 19.79 12.18 44.39 28.93 55 9.25 5.85 17.74 6.18 23.6 1.93z"
                            style={{
                                WebkitTransformOrigin: 241.648,
                                MsTransformOrigin: 241.648,
                                transformOrigin: 241.648,
                            }}
                            id="elzxp67yodjgj"
                            fill="#BA68C8"
                            className="animable"
                        ></path>
                        <path
                            d="M269.13 392c-5.77 6.35-15.38 6.91-26 .22-16.75-10.56-29.71-35.17-28.93-55 .34-8.84 3.37-15.23 8.12-18.65-3.36 3.67-5.44 9.26-5.72 16.5-.78 19.79 12.18 44.39 28.93 55 9.25 5.85 17.74 6.18 23.6 1.93z"
                            style={{
                                WebkitTransformOrigin: 241.648,
                                MsTransformOrigin: 241.648,
                                transformOrigin: 241.648,
                            }}
                            id="elft7o71ik1mu"
                            className="animable"
                            opacity="0.2"
                        ></path>
                        <path
                            d="M246.09 316.09c-18.84-11.89-34.82-3.47-35.69 18.79s13.7 49.94 32.54 61.82 34.83 3.48 35.7-18.79-13.7-49.91-32.55-61.82zm-3 76.13c-16.75-10.56-29.7-35.16-28.93-55s15-27.27 31.73-16.7 29.7 35.16 28.93 54.95-14.95 27.32-31.7 16.75z"
                            style={{
                                WebkitTransformOrigin: 244.52,
                                MsTransformOrigin: 244.52,
                                transformOrigin: 244.52,
                            }}
                            id="elmz9dpdzgeao"
                            fill="#BA68C8"
                            className="animable"
                        ></path>
                        <path
                            d="M274.19 365.64c-.06-.36-.12-.71-.19-1.06l-26.74-8.3-.59-.93L267 344.66l-.45-.84-20.31 10.69-.44-1L254 327l-.77-.74-8.08 26.05-.92-1.13-5.6-34.18c-.34-.11-.68-.22-1-.31l5.54 33.7-1.08-.2-17.37-33-.85.43 17.37 33-.44 1-24.91-23.89c-.12.33-.23.67-.33 1L240.8 353l.41 1.38-26.5-8.22c0 .35.1.7.16 1.05l26.95 8.36.58.93-20.71 10.91c.14.28.28.57.43.85l20.73-10.91.43 1-8.44 27.22.77.75 8.31-26.79.91 1.12 5.78 35.16q.51.17 1 .3l-5.7-34.68 1.08.2 17.74 33.71c.29-.14.56-.3.84-.46l-17.74-33.69.45-1 25.11 24.09.3-1-25.44-24.39-.41-1.39z"
                            style={{
                                WebkitTransformOrigin: 244.45,
                                MsTransformOrigin: 244.45,
                                transformOrigin: 244.45,
                            }}
                            id="eldwzu235cwm8"
                            fill="#EBEBEB"
                            className="animable"
                        ></path>
                        <path
                            d="M246.88 342c-3.23-2-6.19-2.27-8.37-1-.44.26-1 .48-1.56.79-.16.08-.31.18-.47.28h-.08a5 5 0 00-.59.44l-.13.12a4.45 4.45 0 00-.48.49l-.16.2c-.13.17-.26.34-.38.52a3.21 3.21 0 00-.19.31c-.1.17-.19.34-.28.52s-.13.29-.19.43-.15.34-.21.53-.11.37-.17.56-.1.33-.14.5-.09.5-.13.76-.06.28-.08.42c-.05.42-.09.85-.11 1.29-.29 7.42 4.57 16.65 10.86 20.62.39.24.78.46 1.16.66.23.12.46.21.68.3l.47.21.46.15.66.21.25.05c.28.06.56.12.83.15h.06a6 6 0 003.83-.74c.57-.3 1.08-.53 1.74-.89 2.09-1.15 3.45-3.68 3.59-7.31.25-7.36-4.59-16.57-10.87-20.57zm-4.2 22.23c-1.93-1.64-4.54-6.45-5.54-9.12a21.27 21.27 0 002 1.32c3 1.68 3-.44 4.15 1.08s.8 5.12-.24 6.94a1.54 1.54 0 01-.37-.2zm6.44-13.56a2.89 2.89 0 00-.5.21l-1.83.94a2.25 2.25 0 00-.92.85c-1.44-1.58-3-6.53-2.76-8.81 2.57 1 6.76 4.78 7.38 6.2 0 .13.08.24.11.34a7.35 7.35 0 00-1.48.29zm-8.77-1.88c.84 3.55 2.29 4.15 2.34 5.3-2.27-.46-5.91-2.83-6.07-5.05a8.87 8.87 0 012.24-5.82c.95.48.8 2.68 1.49 5.59zm5.86 18.7c-1.17-1.15.22-2.18.93-4.45a6.25 6.25 0 00.1-3.33c2.3 2 5.69 7 4.71 8.47l-.12.15c-2.02.46-4.83 0-5.62-.82zm6-7.42c-2.4-3.48-3.45-2.36-4-4.19a2.32 2.32 0 01.92-2.39 3 3 0 013.62 1.38c1.14 2.24 1.67 6.26 1.64 8.75-.58-.91-1.29-2.22-2.2-3.53z"
                            style={{
                                WebkitTransformOrigin: 245.453,
                                MsTransformOrigin: 245.453,
                                transformOrigin: 245.453,
                            }}
                            id="el4rp286628y"
                            fill="#E0E0E0"
                            className="animable"
                        ></path>
                        <path
                            d="M246.88 342c-3.23-2-6.19-2.27-8.37-1-.44.26-1 .48-1.56.79-.16.08-.31.18-.47.28h-.08a5 5 0 00-.59.44l-.13.12a4.45 4.45 0 00-.48.49l-.16.2c-.13.17-.26.34-.38.52a3.21 3.21 0 00-.19.31c-.1.17-.19.34-.28.52s-.13.29-.19.43-.15.34-.21.53-.11.37-.17.56-.1.33-.14.5-.09.5-.13.76-.06.28-.08.42c-.05.42-.09.85-.11 1.29-.29 7.42 4.57 16.65 10.86 20.62.39.24.78.46 1.16.66.23.12.46.21.68.3l.47.21.46.15.66.21.25.05c.28.06.56.12.83.15h.06a6 6 0 003.83-.74c.57-.3 1.08-.53 1.74-.89 2.09-1.15 3.45-3.68 3.59-7.31.25-7.36-4.59-16.57-10.87-20.57zm-4.2 22.23c-1.93-1.64-4.54-6.45-5.54-9.12a21.27 21.27 0 002 1.32c3 1.68 3-.44 4.15 1.08s.8 5.12-.24 6.94a1.54 1.54 0 01-.37-.2zm6.44-13.56a2.89 2.89 0 00-.5.21l-1.83.94a2.25 2.25 0 00-.92.85c-1.44-1.58-3-6.53-2.76-8.81 2.57 1 6.76 4.78 7.38 6.2 0 .13.08.24.11.34a7.35 7.35 0 00-1.48.29zm-8.77-1.88c.84 3.55 2.29 4.15 2.34 5.3-2.27-.46-5.91-2.83-6.07-5.05a8.87 8.87 0 012.24-5.82c.95.48.8 2.68 1.49 5.59zm5.86 18.7c-1.17-1.15.22-2.18.93-4.45a6.25 6.25 0 00.1-3.33c2.3 2 5.69 7 4.71 8.47l-.12.15c-2.02.46-4.83 0-5.62-.82zm6-7.42c-2.4-3.48-3.45-2.36-4-4.19a2.32 2.32 0 01.92-2.39 3 3 0 013.62 1.38c1.14 2.24 1.67 6.26 1.64 8.75-.58-.91-1.29-2.22-2.2-3.53z"
                            style={{
                                WebkitTransformOrigin: 245.453,
                                MsTransformOrigin: 245.453,
                                transformOrigin: 245.453,
                            }}
                            id="el1mvzskdjxgw"
                            className="animable"
                            opacity="0.2"
                        ></path>
                        <path
                            d="M245 343c-6.28-4-11.61-1.15-11.9 6.26s4.57 16.65 10.86 20.62 11.6 1.15 11.89-6.27S251.33 346.92 245 343zm-2.91.68c2.3.12 7.65 4.82 8.36 6.44s-1.3 1-3.18 1.55c-2.39.74-1.37 3.07-2.73 2.44-1.95-.96-4.7-10.6-2.41-10.47zm-3.45-.49c1.17.24.94 2.56 1.67 5.66.93 3.93 2.61 4.24 2.31 5.68-.43 2.12-7.63-1.35-7.86-4.49s2.74-7.15 3.92-6.89zm2.18 22c-2.44-2.06-6-9.21-6-10.68s1.89.62 4.21 1.95c3 1.68 3-.44 4.15 1.08 1.82 2.21.12 9.71-2.32 7.64zm11.09 3c-1.28 1.87-6.4 1.41-7.57.25s.23-2.18.94-4.45c.9-2.88-.77-4.52.26-5 1.53-.75 7.69 7.35 6.46 9.21zm-1.54-7.19c-2.39-3.47-3.44-2.35-4-4.18-.81-2.67 4.69-5.17 6.35-1.95s2 10.09 1.28 10.84-1.73-1.96-3.63-4.71z"
                            style={{
                                WebkitTransformOrigin: 244.475,
                                MsTransformOrigin: 244.475,
                                transformOrigin: 244.475,
                            }}
                            id="elohhb1odtblr"
                            fill="#E0E0E0"
                            className="animable"
                        ></path>
                        <path
                            d="M244.36 360.51c1.92 1.21 3.55.35 3.64-1.92a7.87 7.87 0 00-3.32-6.3c-1.92-1.22-3.55-.36-3.64 1.91a7.9 7.9 0 003.32 6.31z"
                            style={{
                                WebkitTransformOrigin: 244.52,
                                MsTransformOrigin: 244.52,
                                transformOrigin: 244.52,
                            }}
                            id="el6zg9lirx1ej"
                            fill="#455A64"
                            className="animable"
                        ></path>
                    </g>
                </g>
            </g>
            <g
                id="freepik--Lightnings--inject-2"
                style={{
                    WebkitTransformOrigin: 384.52,
                    MsTransformOrigin: 384.52,
                    transformOrigin: 384.52,
                }}
                className="animable"
            >
                <g
                    id="freepik--Bolts--inject-2"
                    style={{
                        WebkitTransformOrigin: 384.52,
                        MsTransformOrigin: 384.52,
                        transformOrigin: 384.52,
                    }}
                    className="animable"
                >
                    <path
                        style={{
                            WebkitTransformOrigin: 381.765,
                            MsTransformOrigin: 381.765,
                            transformOrigin: 381.765,
                        }}
                        id="elb7czzvh0tpb"
                        fill="#BA68C8"
                        d="M361.36 258.81L372.35 251.93 365.4 246.76 388.33 234.06 377.58 228.8 402.17 213.48 387.91 227.89 400.65 233.22 373.68 247.18 381.01 253.57 361.36 258.81z"
                        className="animable"
                    ></path>
                    <path
                        style={{
                            WebkitTransformOrigin: 357.93,
                            MsTransformOrigin: 357.93,
                            transformOrigin: 357.93,
                        }}
                        id="elefberg500lj"
                        fill="#BA68C8"
                        d="M354.52 244.18L361.46 236.57 357.22 233.84 363.21 225.68 356.81 223.97 358.31 214.02 354.63 224.9 359.16 226.5 352.65 234.72 357.63 237.79 354.52 244.18z"
                        className="animable"
                    ></path>
                    <path
                        style={{
                            WebkitTransformOrigin: 388.52,
                            MsTransformOrigin: 388.52,
                            transformOrigin: 388.52,
                        }}
                        id="el2ffs714o3h4"
                        fill="#BA68C8"
                        d="M360.65 270.13L375.38 280.1 380.03 272.14 392.73 277.96 397.11 268.21 416.39 271.75 393.74 262.77 388.04 271.86 377.5 267.09 373.75 274.66 360.65 270.13z"
                        className="animable"
                    ></path>
                </g>
            </g>
            <g
                id="freepik--speech-bubble--inject-2"
                style={{
                    WebkitTransformOrigin: 291.85,
                    MsTransformOrigin: 291.85,
                    transformOrigin: 291.85,
                }}
                className="animable animator-active"
            >
                <g
                    id="freepik--speech-bubble--inject-2"
                    style={{
                        WebkitTransformOrigin: 291.85,
                        MsTransformOrigin: 291.85,
                        transformOrigin: 291.85,
                    }}
                    className="animable"
                >
                    <g
                        id="freepik--speech-bubble--inject-2"
                        style={{
                            WebkitTransformOrigin: 291.85,
                            MsTransformOrigin: 291.85,
                            transformOrigin: 291.85,
                        }}
                        className="animable"
                    >
                        <path
                            d="M302.93 47.79a29.05 29.05 0 00-21.17 3.11L279 52.72a29.12 29.12 0 0030.55 49.36l2.88-1.69a29.11 29.11 0 00-9.46-52.6z"
                            style={{
                                WebkitTransformOrigin: 296.301,
                                MsTransformOrigin: 296.301,
                                transformOrigin: 296.301,
                            }}
                            id="elgv1y2h93ks"
                            fill="#FFF"
                            className="animable"
                        ></path>
                        <path
                            d="M303.55 45.39a31.67 31.67 0 00-36.41 18.45l-9.73 1.34a1.84 1.84 0 00-.79 3.33l8.09 5.57a31.61 31.61 0 1038.84-28.69zm21.06 37.49a29.07 29.07 0 01-12.26 17.54l-2.88 1.68A29.12 29.12 0 01279 52.69l2.8-1.82a29.12 29.12 0 0142.81 32z"
                            style={{
                                WebkitTransformOrigin: 291.85,
                                MsTransformOrigin: 291.85,
                                transformOrigin: 291.85,
                            }}
                            id="eljq2xg7yq99"
                            fill="#455A64"
                            className="animable"
                        ></path>
                    </g>
                    <path
                        style={{
                            WebkitTransformOrigin: 296.255,
                            MsTransformOrigin: 296.255,
                            transformOrigin: 296.255,
                        }}
                        id="eldstgv8nangb"
                        fill="#BA68C8"
                        d="M302.05 81.95L302.05 93.55 290.45 93.55 290.45 81.95 278.86 81.95 278.86 70.36 290.45 70.36 290.45 58.76 302.05 58.76 302.05 70.36 313.65 70.36 313.65 81.95 302.05 81.95z"
                        className="animable"
                    ></path>
                </g>
            </g>
            <defs>
                <filter id="active" height="200%">
                    <feMorphology
                        in="SourceAlpha"
                        operator="dilate"
                        radius="2"
                        result="DILATED"
                    ></feMorphology>
                    <feFlood
                        floodColor="#32DFEC"
                        floodOpacity="1"
                        result="PINK"
                    ></feFlood>
                    <feComposite
                        in="PINK"
                        in2="DILATED"
                        operator="in"
                        result="OUTLINE"
                    ></feComposite>
                    <feMerge>
                        <feMergeNode in="OUTLINE"></feMergeNode>
                        <feMergeNode in="SourceGraphic"></feMergeNode>
                    </feMerge>
                </filter>
                <filter id="hover" height="200%">
                    <feMorphology
                        in="SourceAlpha"
                        operator="dilate"
                        radius="2"
                        result="DILATED"
                    ></feMorphology>
                    <feFlood floodColor="red" floodOpacity="0.5" result="PINK"></feFlood>
                    <feComposite
                        in="PINK"
                        in2="DILATED"
                        operator="in"
                        result="OUTLINE"
                    ></feComposite>
                    <feMerge>
                        <feMergeNode in="OUTLINE"></feMergeNode>
                        <feMergeNode in="SourceGraphic"></feMergeNode>
                    </feMerge>
                    <feColorMatrix values="0 0 0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 1 0"></feColorMatrix>
                </filter>
            </defs>
        </svg>
    );
}
